var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingPlansNotCss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-pricing-plans",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-75",
    className: "animable",
    style: {
      transformOrigin: "250px 345.72px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-75",
    cx: 250,
    cy: 345.72,
    rx: 240.78,
    ry: 139.01,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250px 345.72px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-75",
    className: "animable",
    style: {
      transformOrigin: "412.48px 124.13px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-75",
    className: "animable",
    style: {
      transformOrigin: "412.48px 124.13px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.37,101.59c0-25.69-16.92-56.29-37.79-68.33-11.05-6.38-21-6.28-27.9-1-8.59,3.57-14.09,13.45-14.09,28.09V176.25l75.58,43.63,4.2-2.42Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "412.48px 124.13px"
    },
    id: "el0bf3oze06res",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.17,219.88V104c0-25.69-16.92-56.28-37.79-68.33s-37.79-1-37.79,24.7V176.25Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "410.38px 125.337px"
    },
    id: "elmakgf1zw9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,104V212.72l-67.31-38.86V60.38c0-12.84,4.51-21.69,12.11-24.49a15.71,15.71,0,0,1,5.51-1c4.3,0,9,1.45,14,4.32C428,50.63,444,79.68,444,104Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.345px 123.805px"
    },
    id: "eldznnly4n6z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.73 173.86 381 171.4 444.04 207.8 444.04 212.72 376.73 173.86",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "410.385px 192.06px"
    },
    id: "elxnt8jz1qfpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,104V207.8l-63-36.4V57.91c0-10.2,2.86-17.89,7.85-22a15.71,15.71,0,0,1,5.51-1c4.3,0,9,1.45,14,4.32C428,50.63,444,79.68,444,104Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "412.5px 121.355px"
    },
    id: "elxgnok4h2njk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.45 194.48 408.31 192.09 408.31 37.77 412.45 37.77 412.45 194.48",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "410.38px 116.125px"
    },
    id: "elx3xe99cm4z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.58,45.24V192.1l-4.13,2.38V41.94Q414.55,43.46,416.58,45.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "414.515px 118.21px"
    },
    id: "elwjjmgglt03g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.73 144.7 408.31 162.94 408.31 167.78 376.73 149.55 376.73 144.7",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "392.52px 156.24px"
    },
    id: "elbemf3aqocc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381 142.24 376.73 144.7 408.31 162.94 408.31 158.09 381 142.24",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "392.52px 152.59px"
    },
    id: "ellaxigxs0wfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.45 165.32 444.04 183.56 444.04 188.4 412.45 170.17 412.45 165.32",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "428.245px 176.86px"
    },
    id: "eljl54sc8sd0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.72 162.86 412.45 165.32 444.04 183.56 444.04 178.71 416.72 162.86",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "428.245px 173.21px"
    },
    id: "elqrh59mpmb4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.73 69.58 408.31 87.82 408.31 92.67 376.73 74.44 376.73 69.58",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "392.52px 81.125px"
    },
    id: "elr3vigfzsq98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381 67.12 376.73 69.58 408.31 87.82 408.31 82.97 381 67.12",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "392.52px 77.47px"
    },
    id: "elnra5cv4b6df",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.45 90.2 444.04 108.44 444.04 113.29 412.45 95.06 412.45 90.2",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "428.245px 101.745px"
    },
    id: "elcb3x5kflv7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.72 87.74 412.45 90.2 444.04 108.44 444.04 103.59 416.72 87.74",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "428.245px 98.09px"
    },
    id: "el8lu38wwu32i",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-75",
    className: "animable",
    style: {
      transformOrigin: "107.825px 88.175px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-75",
    className: "animable",
    style: {
      transformOrigin: "73.255px 108.11px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-75",
    className: "animable",
    style: {
      transformOrigin: "73.255px 108.11px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.92 142.21 53 143.45 95.62 118.84 93.54 117.6 50.92 142.21",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "73.27px 130.525px"
    },
    id: "elvkk0uef0ab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.54 117.6 53 141 53 98.55 93.54 75.16 93.54 117.6",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "73.27px 108.08px"
    },
    id: "elrnhnyfrzfz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,67.15,49.08,96.28v54L99.54,121.1Zm-3.92,51.69L53,143.45V98.55L95.62,73.94Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.31px 108.715px"
    },
    id: "elmgaig72tpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.62 118.84 93.54 117.6 93.54 75.16 95.62 73.94 95.62 118.84",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "94.58px 96.39px"
    },
    id: "eluwx3vxhiy6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.54 67.15 97.43 65.94 46.97 95.08 49.08 96.28 99.54 67.15",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "73.255px 81.11px"
    },
    id: "elg8ojhliiyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.97 95.08 49.08 96.28 49.08 150.24 46.97 149.03 46.97 95.08",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "48.025px 122.66px"
    },
    id: "el6gme4u685wx",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-75",
    className: "animable",
    style: {
      transformOrigin: "73.27px 115.145px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "91.96 116.33 54.58 137.91 54.58 127.12 63.93 105.54 69.75 110.94 67.66 119.98 80.56 92.38 91.96 105.54 91.96 116.33",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "73.27px 115.145px"
    },
    id: "el6hyzaha0unb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4,95.12a6.11,6.11,0,0,0-2.77,4.79c0,1.76,1.24,2.48,2.77,1.6a6.15,6.15,0,0,0,2.76-4.79C72.16,95,70.92,94.24,69.4,95.12Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "69.395px 98.3185px"
    },
    id: "elgb3r9w6bx6r",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-75",
    className: "animable",
    style: {
      transformOrigin: "142.395px 68.245px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-75",
    className: "animable",
    style: {
      transformOrigin: "142.395px 68.245px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "120.06 102.34 122.14 103.58 164.76 78.97 162.69 77.73 120.06 102.34",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "142.41px 90.655px"
    },
    id: "elcooejmo9e6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.69 77.73 122.14 101.14 122.14 58.68 162.69 35.29 162.69 77.73",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "142.415px 68.215px"
    },
    id: "el7ize4j2jinn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.68,27.28,118.22,56.42v54l50.46-29.14ZM164.76,79l-42.62,24.61V58.68l42.62-24.61Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "143.45px 68.85px"
    },
    id: "elbwa09sxf1na",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.76 78.97 162.69 77.73 162.69 35.29 164.76 34.07 164.76 78.97",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.725px 56.52px"
    },
    id: "elo498pp3e2ci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.68 27.28 166.57 26.07 116.11 55.21 118.22 56.41 168.68 27.28",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "142.395px 41.24px"
    },
    id: "elpsx8oujbbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.11 55.21 118.22 56.41 118.22 110.37 116.11 109.16 116.11 55.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "117.165px 82.79px"
    },
    id: "elyfep2581vk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-75",
    className: "animable",
    style: {
      transformOrigin: "142.41px 75.275px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "161.1 76.46 123.72 98.04 123.72 87.25 133.07 65.67 138.89 71.07 136.8 80.11 149.71 52.51 161.1 65.67 161.1 76.46",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "142.41px 75.275px"
    },
    id: "el53bp38p55rn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.54,55.25A6.1,6.1,0,0,0,135.78,60c0,1.76,1.23,2.48,2.76,1.6a6.1,6.1,0,0,0,2.76-4.79C141.3,55.09,140.07,54.37,138.54,55.25Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "138.54px 58.4245px"
    },
    id: "elqs5k3uwljdr",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-75",
    className: "animable",
    style: {
      transformOrigin: "375.605px 366.257px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-75",
    d: "M469.16,307.53c-16.3-9.41-42.72-9.41-59,0s-16.29,24.66,0,34.07,42.72,9.41,59,0S485.46,316.94,469.16,307.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.662px 324.565px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-75",
    d: "M397.72,419.37c29.25-16.89,29.25-44.28,0-61.17s-76.7-16.89-105.95,0-29.25,44.27,0,61.17S368.46,436.26,397.72,419.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "344.745px 388.787px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-75",
    className: "animable",
    style: {
      transformOrigin: "465.574px 275.099px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-75",
    className: "animable",
    style: {
      transformOrigin: "465.574px 275.099px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.47,305.55l-7.72-4.46S442.15,282,444,264.8c2.58-24.17,18.49-33.27,24.54-31.18s7.8,9.12-2.21,23.51C460.4,265.62,453.15,283.31,454.47,305.55Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "458.51px 269.44px"
    },
    id: "elut9vpiwx3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0mf68zw65ual"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "458.51px 269.44px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.47,305.55l-7.72-4.46S442.15,282,444,264.8c2.58-24.17,18.49-33.27,24.54-31.18s7.8,9.12-2.21,23.51C460.4,265.62,453.15,283.31,454.47,305.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "458.51px 269.44px"
    },
    id: "elrsxg3v6tx8i",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M451.27,296.17h.08a.53.53,0,0,0,.42-.63c-4.23-22.29,3.56-47.34,13.2-57.76a.54.54,0,1,0-.79-.73c-9.82,10.62-17.76,36.07-13.46,58.69A.54.54,0,0,0,451.27,296.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "457.336px 266.505px"
    },
    id: "elz4ofns64efe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.92,316.78c1.15.59,4.22-2,5.07-2.68a10.66,10.66,0,0,0,3.36-4.27,10.06,10.06,0,0,0,.59-6.06,23.47,23.47,0,0,0-.93-3.17L481,297.54a8,8,0,0,1-.61-3.12c.16-2.14,2-3.72,3.63-5.09,1.82-1.52,3.7-3.49,3.56-6.05A9,9,0,0,0,485,278c-1.31-1.49-2.83-2.79-4-4.37a6.29,6.29,0,0,1-1.48-3.91,6.36,6.36,0,0,1,.74-2.53,36,36,0,0,0,2.47-5.12c.53-1.82.33-4.05-1.14-5.26a5.89,5.89,0,0,0-4.46-.87,10.18,10.18,0,0,0-4,1.65c-3.95,2.46-6,7.39-10.25,9.35a43.17,43.17,0,0,1-5.16,1.54,6.46,6.46,0,0,0-4.15,3.16c-1.43,3.25,1.71,7,.76,10.41-.83,3-3.66,4.3-5.15,7.06a6.39,6.39,0,0,0-.56,3.93,18.67,18.67,0,0,0,2,6.49,58.48,58.48,0,0,0,3.9,6S473.74,316.69,473.92,316.78Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "468.055px 286.343px"
    },
    id: "eln6krfz7bzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6lc40fhz73h"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "468.055px 286.343px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.92,316.78c1.15.59,4.22-2,5.07-2.68a10.66,10.66,0,0,0,3.36-4.27,10.06,10.06,0,0,0,.59-6.06,23.47,23.47,0,0,0-.93-3.17L481,297.54a8,8,0,0,1-.61-3.12c.16-2.14,2-3.72,3.63-5.09,1.82-1.52,3.7-3.49,3.56-6.05A9,9,0,0,0,485,278c-1.31-1.49-2.83-2.79-4-4.37a6.29,6.29,0,0,1-1.48-3.91,6.36,6.36,0,0,1,.74-2.53,36,36,0,0,0,2.47-5.12c.53-1.82.33-4.05-1.14-5.26a5.89,5.89,0,0,0-4.46-.87,10.18,10.18,0,0,0-4,1.65c-3.95,2.46-6,7.39-10.25,9.35a43.17,43.17,0,0,1-5.16,1.54,6.46,6.46,0,0,0-4.15,3.16c-1.43,3.25,1.71,7,.76,10.41-.83,3-3.66,4.3-5.15,7.06a6.39,6.39,0,0,0-.56,3.93,18.67,18.67,0,0,0,2,6.49,58.48,58.48,0,0,0,3.9,6S473.74,316.69,473.92,316.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "468.055px 286.343px"
    },
    id: "elfh75ngfrg6q",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M462.73,311h0a.51.51,0,0,0,.46-.55c-1.85-20,6.5-42.71,13.06-49.5a.51.51,0,0,0,0-.72.52.52,0,0,0-.72,0c-6.69,6.93-15.21,30-13.34,50.3A.51.51,0,0,0,462.73,311Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "469.163px 285.543px"
    },
    id: "elitfa5xhz3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.73,286.23l.14,0a68.55,68.55,0,0,1,14.47-3.09.5.5,0,0,0,.45-.55.48.48,0,0,0-.55-.46,69.36,69.36,0,0,0-14.71,3.15.51.51,0,0,0-.31.65A.52.52,0,0,0,464.73,286.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "471.992px 284.178px"
    },
    id: "eln9knrm1oyz9",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-75",
    className: "animable",
    style: {
      transformOrigin: "438.652px 313.19px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-75",
    className: "animable",
    style: {
      transformOrigin: "438.652px 313.19px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.24,315a24.13,24.13,0,0,0-8.93-8.26c-14.6-8.43-38.26-8.43-52.86,0a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.9,10.58,10.92,14.63,14.6,8.43,38.26,8.43,52.86,0,7-4.05,10.68-9.32,10.95-14.63h0V315Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "439.885px 322px"
    },
    id: "els2rg8o41k7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfyxjeq1fajb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "439.885px 322px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.24,315a24.13,24.13,0,0,0-8.93-8.26c-14.6-8.43-38.26-8.43-52.86,0a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.9,10.58,10.92,14.63,14.6,8.43,38.26,8.43,52.86,0,7-4.05,10.68-9.32,10.95-14.63h0V315Z",
    id: "elxiteb20nxg",
    className: "animable",
    style: {
      transformOrigin: "439.885px 322px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eleebluannkpw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.88,300.39c-9.56,0-19.13,2.11-26.43,6.32a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.9,10.58,10.92,14.63,7.3,4.21,16.87,6.32,26.43,6.32Z",
    style: {
      opacity: 0.1,
      transformOrigin: "421.2px 321.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elirprbmqkbug"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.47,303.89a40.55,40.55,0,0,0-6,2.82,24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.9,10.58,10.92,14.63a41.58,41.58,0,0,0,6,2.82Z",
    style: {
      opacity: 0.1,
      transformOrigin: "411.005px 321.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elurutfh0ibk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.3,303.89a40.91,40.91,0,0,1,6,2.82,24.13,24.13,0,0,1,8.93,8.26h2v7.63h0c-.27,5.31-3.93,10.58-10.95,14.63a42,42,0,0,1-6,2.82Z",
    style: {
      fill: "rgb(9, 65, 108)",
      opacity: 0.5,
      transformOrigin: "468.755px 321.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M466.31,299.71c-14.6-8.43-38.26-8.43-52.86,0s-14.6,22.09,0,30.52,38.26,8.43,52.86,0S480.91,308.14,466.31,299.71Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "439.88px 314.97px"
    },
    id: "elcmq1vyb74e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6sd84zvywlc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.31,299.71c-14.6-8.43-38.26-8.43-52.86,0s-14.6,22.09,0,30.52,38.26,8.43,52.86,0S480.91,308.14,466.31,299.71Z",
    style: {
      opacity: 0.2,
      transformOrigin: "439.88px 314.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.09,305.29a42.19,42.19,0,0,0-34.42,0c-4.89,2.51-7.59,5.95-7.59,9.68s2.7,7.17,7.59,9.67a42.08,42.08,0,0,0,34.42,0c4.89-2.5,7.59-5.94,7.59-9.67S462,307.8,457.09,305.29Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "439.88px 314.97px"
    },
    id: "eluam8c38ft8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmk8sqifcnnc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.09,305.29a42.19,42.19,0,0,0-34.42,0c-4.89,2.51-7.59,5.95-7.59,9.68s2.7,7.17,7.59,9.67a42.08,42.08,0,0,0,34.42,0c4.89-2.5,7.59-5.94,7.59-9.67S462,307.8,457.09,305.29Z",
    style: {
      opacity: 0.4,
      transformOrigin: "439.88px 314.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.5,301.12c-6.82-3.94-15.92-6.11-25.62-6.11s-18.8,2.17-25.61,6.11c-6.54,3.78-10.14,8.69-10.14,13.85s3.6,10.08,10.14,13.85c6.81,3.93,15.91,6.1,25.61,6.1s18.8-2.17,25.62-6.1c6.53-3.77,10.13-8.69,10.13-13.85S472,304.9,465.5,301.12Zm-8.41,23.52a42.08,42.08,0,0,1-34.42,0c-4.89-2.5-7.59-5.94-7.59-9.67s2.7-7.17,7.59-9.68a42.19,42.19,0,0,1,34.42,0c4.89,2.51,7.59,5.95,7.59,9.68S462,322.14,457.09,324.64Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "439.88px 314.965px"
    },
    id: "eluvp7c6kesd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmulre70c4lh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.5,301.12c-6.82-3.94-15.92-6.11-25.62-6.11s-18.8,2.17-25.61,6.11c-6.54,3.78-10.14,8.69-10.14,13.85s3.6,10.08,10.14,13.85c6.81,3.93,15.91,6.1,25.61,6.1s18.8-2.17,25.62-6.1c6.53-3.77,10.13-8.69,10.13-13.85S472,304.9,465.5,301.12Zm-8.41,23.52a42.08,42.08,0,0,1-34.42,0c-4.89-2.5-7.59-5.94-7.59-9.67s2.7-7.17,7.59-9.68a42.19,42.19,0,0,1,34.42,0c4.89,2.51,7.59,5.95,7.59,9.68S462,322.14,457.09,324.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "439.88px 314.965px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5quxmvo7lxe"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.88,
    cy: 314.97,
    rx: 23.51,
    ry: 12.06,
    style: {
      opacity: 0.2,
      transformOrigin: "439.88px 314.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.88,
    cy: 314.97,
    rx: 23.51,
    ry: 12.06,
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "439.88px 314.97px"
    },
    id: "ela3qfn32tp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm034lthqb3b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.88,
    cy: 314.97,
    rx: 23.51,
    ry: 12.06,
    style: {
      opacity: 0.45,
      transformOrigin: "439.88px 314.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M456.5,309.63c-9.18-4.71-24.06-4.71-33.24,0-3.8,1.95-6,4.4-6.68,6.94.66,2.53,2.88,5,6.68,6.93,9.18,4.71,24.06,4.71,33.24,0,3.8-1.95,6-4.4,6.68-6.93C462.52,314,460.3,311.58,456.5,309.63Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "439.88px 316.565px"
    },
    id: "elhkj0ijmxi7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el80x8p3yaaz8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.5,309.63c-9.18-4.71-24.06-4.71-33.24,0-3.8,1.95-6,4.4-6.68,6.94.66,2.53,2.88,5,6.68,6.93,9.18,4.71,24.06,4.71,33.24,0,3.8-1.95,6-4.4,6.68-6.93C462.52,314,460.3,311.58,456.5,309.63Z",
    style: {
      opacity: 0.3,
      transformOrigin: "439.88px 316.565px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "442.11 306.62 442.11 310.07 440.93 311.31 438.75 313.59 438.75 310 442.11 306.62",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "440.43px 310.105px"
    },
    id: "el8xeaovp209j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el74jd8a6j3vh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "442.11 306.62 442.11 310.07 440.93 311.31 438.75 313.59 438.75 310 442.11 306.62",
    style: {
      opacity: 0.3,
      transformOrigin: "440.43px 310.105px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.75,310v2a18.84,18.84,0,0,1-3.34,1,3.08,3.08,0,0,1-2.12-.33c-.83-.5-1-1.23.62-2.14A5.5,5.5,0,0,1,438.75,310Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "435.712px 311.365px"
    },
    id: "el5ywfcvamolb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4cre5a4420b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.75,310v2a18.84,18.84,0,0,1-3.34,1,3.08,3.08,0,0,1-2.12-.33c-.83-.5-1-1.23.62-2.14A5.5,5.5,0,0,1,438.75,310Z",
    style: {
      opacity: 0.45,
      transformOrigin: "435.712px 311.365px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.36,319.79v3l-3.77,2.17-2.79-1.61a14.24,14.24,0,0,1-10.8.49v-3l1.71-1.7-1.71.47a11,11,0,0,1-8.41-1c-1.69-1-2.47-2-2.47-3.14v-2.9l.3-1.27-1-.59v-3l2.78,1.61c-1.36,1.06-2.08,2.14-2.06,3.2v0c0,1.07.82,2.11,2.47,3.06,3.67,2.12,7.3,1.42,10.63.35,3.09-1,5.35-2.19,7.13-1.16,1.11.64.77,1.41-.47,2.13a6.14,6.14,0,0,1-5.31.31L437,320.84a12.48,12.48,0,0,0,2,.57,14.63,14.63,0,0,0,8.83-1.06l2.79,1.62Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "439.89px 316.335px"
    },
    id: "elzyuwounfo69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldg8dyryslg8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.12,312.58v0c0,1.07.82,2.11,2.47,3.06,3.67,2.12,7.3,1.42,10.63.35,3.09-1,5.35-2.19,7.13-1.16,1.11.64.77,1.41-.47,2.13a6.14,6.14,0,0,1-5.31.31L437,320.84a12.48,12.48,0,0,0,2,.57,14.63,14.63,0,0,0,8.83-1.06l2.79,1.62,3.77-2.18v3l-3.77,2.17-2.79-1.61a14.24,14.24,0,0,1-10.8.49v-3l1.71-1.7-1.71.47a11,11,0,0,1-8.41-1c-1.69-1-2.47-2-2.47-3.14v-2.9l.3-1.27",
    style: {
      opacity: 0.2,
      transformOrigin: "440.255px 318.13px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz8eqqonr77s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.4,307.77v3l1,.59h0a6.15,6.15,0,0,1,1.76-2Z",
    style: {
      opacity: 0.45,
      transformOrigin: "426.78px 309.565px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M453.73,317.84a3.36,3.36,0,0,1-.28,1.42l-1.88-1.08a3.72,3.72,0,0,0,2.14-2.87C453.72,316.13,453.73,317.76,453.73,317.84Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "452.65px 317.285px"
    },
    id: "eljgvhq4clupa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4rz38rr3gfw"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "452.65px 317.285px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.73,317.84a3.36,3.36,0,0,1-.28,1.42l-1.88-1.08a3.72,3.72,0,0,0,2.14-2.87C453.72,316.13,453.73,317.76,453.73,317.84Z",
    id: "elsj2l6cfd57p",
    className: "animable",
    style: {
      transformOrigin: "452.65px 317.285px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M453.73,319.43l-2.16-1.25a3.68,3.68,0,0,0,2.16-3.31,2.64,2.64,0,0,0,0-.29c-.09-1-.85-2-2.41-2.92h0a9.82,9.82,0,0,0-5-1.31h-.47l-.45,0-.39,0-.16,0-.3,0a20.65,20.65,0,0,0-2.44.5l-1.14.34-1.58.51-.6.21a17.8,17.8,0,0,1-3.34,1,3.43,3.43,0,0,1-1.44-.05,3.27,3.27,0,0,1-.67-.28c-.84-.49-1-1.23.61-2.14a5.51,5.51,0,0,1,4.84-.51l3.36-3.38a14.4,14.4,0,0,0-10.12.56l-2.79-1.6-3.8,2.19,2.79,1.61c-1.37,1.05-2.09,2.15-2.08,3.2v0c0,1.07.83,2.11,2.48,3.06,3.67,2.12,7.31,1.42,10.63.35,3.09-1,5.34-2.2,7.13-1.17,1.11.65.77,1.42-.47,2.14a6.14,6.14,0,0,1-5.31.31L437,320.84a13.7,13.7,0,0,0,2,.58,13.5,13.5,0,0,0,3.44.25,16,16,0,0,0,5.39-1.32l2.79,1.62,3.76-2.18Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "439.91px 313.74px"
    },
    id: "elutsc8tpi5gb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el764cbvblvxp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "439.91px 313.74px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.73,319.43l-2.16-1.25a3.68,3.68,0,0,0,2.16-3.31,2.64,2.64,0,0,0,0-.29c-.09-1-.85-2-2.41-2.92h0a9.82,9.82,0,0,0-5-1.31h-.47l-.45,0-.39,0-.16,0-.3,0a20.65,20.65,0,0,0-2.44.5l-1.14.34-1.58.51-.6.21a17.8,17.8,0,0,1-3.34,1,3.43,3.43,0,0,1-1.44-.05,3.27,3.27,0,0,1-.67-.28c-.84-.49-1-1.23.61-2.14a5.51,5.51,0,0,1,4.84-.51l3.36-3.38a14.4,14.4,0,0,0-10.12.56l-2.79-1.6-3.8,2.19,2.79,1.61c-1.37,1.05-2.09,2.15-2.08,3.2v0c0,1.07.83,2.11,2.48,3.06,3.67,2.12,7.31,1.42,10.63.35,3.09-1,5.34-2.2,7.13-1.17,1.11.65.77,1.42-.47,2.14a6.14,6.14,0,0,1-5.31.31L437,320.84a13.7,13.7,0,0,0,2,.58,13.5,13.5,0,0,0,3.44.25,16,16,0,0,0,5.39-1.32l2.79,1.62,3.76-2.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "439.91px 313.74px"
    },
    id: "ela6staeeig8w",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "447.8 320.35 447.8 323.33 450.59 324.94 450.59 321.96 447.8 320.35",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "449.195px 322.645px"
    },
    id: "eltv7dzt42phb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4vbq872xgcp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "447.8 320.35 447.8 323.33 450.59 324.94 450.59 321.96 447.8 320.35",
    style: {
      opacity: 0.45,
      transformOrigin: "449.195px 322.645px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz542v3lz4ml"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "425.39 307.77 429.2 305.57 431.99 307.18 429.22 306.02 425.39 307.77",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "428.69px 306.67px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elg1bqmjl1srf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.91,310.51a5.51,5.51,0,0,1,4.84-.51l3.36-3.38-3.36,3A5.06,5.06,0,0,0,433.91,310.51Z",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "438.01px 308.565px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elval7mtvyrf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437,320.84a13.7,13.7,0,0,0,2,.58,13.5,13.5,0,0,0,3.44.25,12.15,12.15,0,0,1-4.85-1l3-3.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "439.72px 319.48px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhksdizhrz1t"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "447.8 320.35 450.59 321.61 454.35 319.79 450.59 321.96 447.8 320.35",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "451.075px 320.875px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4v44vcwci88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.55,301.62c9.9-6,25.33-6.61,25.33-6.61-9.7,0-18.8,2.17-25.61,6.11-6.54,3.78-10.14,8.69-10.14,13.85C404.13,315,404.49,307.74,414.55,301.62Z",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "422.005px 304.99px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eloihwcx44b18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437,336.49c10.5.46,21.28-1.62,29.31-6.26,8.36-4.82,11.93-11.36,10.72-17.65,0,0,1.56,10.25-11.35,17.27S437,336.49,437,336.49Z",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "457.13px 324.566px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M472.79,304.38a24.13,24.13,0,0,0-8.93-8.26c-14.6-8.43-38.27-8.43-52.87,0a24.09,24.09,0,0,0-8.92,8.26h-2V312h0c.27,5.31,3.91,10.58,10.92,14.63,14.6,8.43,38.27,8.43,52.87,0,7-4.05,10.68-9.32,10.95-14.63h0v-7.63Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.44px 311.375px"
    },
    id: "el41ryzym8dis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsl6yhv4608"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "437.44px 311.375px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.79,304.38a24.13,24.13,0,0,0-8.93-8.26c-14.6-8.43-38.27-8.43-52.87,0a24.09,24.09,0,0,0-8.92,8.26h-2V312h0c.27,5.31,3.91,10.58,10.92,14.63,14.6,8.43,38.27,8.43,52.87,0,7-4.05,10.68-9.32,10.95-14.63h0v-7.63Z",
    id: "eln1ay3w9y63",
    className: "animable",
    style: {
      transformOrigin: "437.44px 311.375px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ellziw6oh75ze"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.43,289.8c-9.57,0-19.14,2.11-26.44,6.32a24.09,24.09,0,0,0-8.92,8.26h-2V312h0c.27,5.31,3.91,10.58,10.92,14.63,7.3,4.21,16.87,6.32,26.44,6.32Z",
    style: {
      opacity: 0.1,
      transformOrigin: "418.75px 311.375px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el98mrpt7x6k5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,293.3a41.58,41.58,0,0,0-6,2.82,24.09,24.09,0,0,0-8.92,8.26h-2V312h0c.27,5.31,3.91,10.58,10.92,14.63a40.55,40.55,0,0,0,6,2.82Z",
    style: {
      opacity: 0.1,
      transformOrigin: "408.54px 311.375px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwnpx847laj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.84,293.3a41.58,41.58,0,0,1,6,2.82,24.13,24.13,0,0,1,8.93,8.26h2V312h0c-.27,5.31-3.93,10.58-10.95,14.63a40.55,40.55,0,0,1-6,2.82Z",
    style: {
      fill: "rgb(9, 65, 108)",
      opacity: 0.5,
      transformOrigin: "466.295px 311.375px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463.86,289.12c-14.6-8.43-38.27-8.43-52.87,0s-14.59,22.09,0,30.52,38.27,8.43,52.87,0S478.45,297.55,463.86,289.12Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.425px 304.38px"
    },
    id: "elbtu3us93jaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellka5xyfwa4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.86,289.12c-14.6-8.43-38.27-8.43-52.87,0s-14.59,22.09,0,30.52,38.27,8.43,52.87,0S478.45,297.55,463.86,289.12Z",
    style: {
      opacity: 0.2,
      transformOrigin: "437.425px 304.38px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.64,294.71a42.08,42.08,0,0,0-34.42,0c-4.9,2.5-7.59,5.94-7.59,9.67s2.69,7.17,7.59,9.68a42.19,42.19,0,0,0,34.42,0c4.89-2.51,7.58-5.95,7.58-9.68S459.53,297.21,454.64,294.71Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.425px 304.38px"
    },
    id: "elpvhq31qutgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu7dlg0izdse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.64,294.71a42.08,42.08,0,0,0-34.42,0c-4.9,2.5-7.59,5.94-7.59,9.67s2.69,7.17,7.59,9.68a42.19,42.19,0,0,0,34.42,0c4.89-2.51,7.58-5.95,7.58-9.68S459.53,297.21,454.64,294.71Z",
    style: {
      opacity: 0.4,
      transformOrigin: "437.425px 304.38px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463.05,290.53c-6.82-3.93-15.92-6.11-25.63-6.11s-18.79,2.18-25.61,6.11c-6.54,3.78-10.13,8.69-10.13,13.85s3.59,10.08,10.13,13.86c6.82,3.92,15.91,6.1,25.61,6.1s18.81-2.18,25.63-6.1c6.53-3.78,10.13-8.7,10.13-13.86S469.58,294.31,463.05,290.53Zm-8.41,23.53a42.19,42.19,0,0,1-34.42,0c-4.9-2.51-7.59-5.95-7.59-9.68s2.69-7.17,7.59-9.67a42.08,42.08,0,0,1,34.42,0c4.89,2.5,7.58,5.94,7.58,9.67S459.53,311.55,454.64,314.06Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.43px 304.38px"
    },
    id: "elfbhxy9cmoj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9f08xhriqw9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.05,290.53c-6.82-3.93-15.92-6.11-25.63-6.11s-18.79,2.18-25.61,6.11c-6.54,3.78-10.13,8.69-10.13,13.85s3.59,10.08,10.13,13.86c6.82,3.92,15.91,6.1,25.61,6.1s18.81-2.18,25.63-6.1c6.53-3.78,10.13-8.7,10.13-13.86S469.58,294.31,463.05,290.53Zm-8.41,23.53a42.19,42.19,0,0,1-34.42,0c-4.9-2.51-7.59-5.95-7.59-9.68s2.69-7.17,7.59-9.67a42.08,42.08,0,0,1,34.42,0c4.89,2.5,7.58,5.94,7.58,9.67S459.53,311.55,454.64,314.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "437.43px 304.38px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvzxsdqxyfu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.05,312.91c9.18-4.71,9.18-12.35,0-17.06s-24.07-4.71-33.25,0-9.18,12.35,0,17.06S444.87,317.62,454.05,312.91Z",
    style: {
      opacity: 0.2,
      transformOrigin: "437.425px 304.38px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.05,312.91c9.18-4.71,9.18-12.35,0-17.06s-24.07-4.71-33.25,0-9.18,12.35,0,17.06S444.87,317.62,454.05,312.91Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.425px 304.38px"
    },
    id: "eln53ukwkjq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellc4zdf10z3g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.05,312.91c9.18-4.71,9.18-12.35,0-17.06s-24.07-4.71-33.25,0-9.18,12.35,0,17.06S444.87,317.62,454.05,312.91Z",
    style: {
      opacity: 0.45,
      transformOrigin: "437.425px 304.38px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.05,299c-9.18-4.71-24.07-4.71-33.25,0-3.79,1.95-6,4.4-6.67,6.94.65,2.53,2.88,5,6.67,6.93,9.18,4.71,24.07,4.71,33.25,0,3.8-2,6-4.4,6.68-6.93C460.07,303.44,457.85,301,454.05,299Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.43px 305.935px"
    },
    id: "eln0dmotwk63k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el219qe70c6a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.05,299c-9.18-4.71-24.07-4.71-33.25,0-3.79,1.95-6,4.4-6.67,6.94.65,2.53,2.88,5,6.67,6.93,9.18,4.71,24.07,4.71,33.25,0,3.8-2,6-4.4,6.68-6.93C460.07,303.44,457.85,301,454.05,299Z",
    style: {
      opacity: 0.3,
      transformOrigin: "437.43px 305.935px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "439.65 296.03 439.65 299.48 438.48 300.72 436.3 303 436.3 299.41 439.65 296.03",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.975px 299.515px"
    },
    id: "elmz0dh4smpts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljizz0wn818l"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "439.65 296.03 439.65 299.48 438.48 300.72 436.3 303 436.3 299.41 439.65 296.03",
    style: {
      opacity: 0.3,
      transformOrigin: "437.975px 299.515px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.3,299.41v2a19.55,19.55,0,0,1-3.35.95,3.74,3.74,0,0,1-1.43-.06,3.05,3.05,0,0,1-.68-.28c-.83-.49-1-1.23.61-2.14A5.52,5.52,0,0,1,436.3,299.41Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "433.261px 300.729px"
    },
    id: "eldowxyqj4j9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldcgpnebr3v9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.3,299.41v2a19.55,19.55,0,0,1-3.35.95,3.74,3.74,0,0,1-1.43-.06,3.05,3.05,0,0,1-.68-.28c-.83-.49-1-1.23.61-2.14A5.52,5.52,0,0,1,436.3,299.41Z",
    style: {
      opacity: 0.45,
      transformOrigin: "433.261px 300.729px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.9,309.2v3l-3.77,2.17-2.79-1.61a14.21,14.21,0,0,1-10.79.49v-3l1.71-1.7-1.71.47a11,11,0,0,1-8.41-1c-1.7-1-2.48-2-2.48-3.14V302l.31-1.27-1-.59v-3l2.79,1.61c-1.36,1.06-2.08,2.14-2.07,3.2v0c0,1.07.83,2.11,2.48,3.06,3.66,2.12,7.3,1.42,10.62.35,3.1-1,5.35-2.19,7.14-1.16,1.11.64.77,1.42-.47,2.14a6.19,6.19,0,0,1-5.32.3l-3.56,3.54a13.7,13.7,0,0,0,2,.58,14.66,14.66,0,0,0,8.82-1.07l2.79,1.62Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.435px 305.755px"
    },
    id: "eltwlg9vpezkr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo5vbjfr0t98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.66,302v0c0,1.07.83,2.11,2.48,3.06,3.66,2.12,7.3,1.42,10.62.35,3.1-1,5.35-2.19,7.14-1.16,1.11.64.77,1.42-.47,2.14a6.19,6.19,0,0,1-5.32.3l-3.56,3.54a13.7,13.7,0,0,0,2,.58,14.66,14.66,0,0,0,8.82-1.07l2.79,1.62,3.77-2.18v3l-3.77,2.17-2.79-1.61a14.21,14.21,0,0,1-10.79.49v-3l1.71-1.7-1.71.47a11,11,0,0,1-8.41-1c-1.7-1-2.48-2-2.48-3.14V302l.31-1.27",
    style: {
      opacity: 0.2,
      transformOrigin: "437.795px 307.54px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el60lsvvnv82a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.94,297.18v3l1,.59h0a6.08,6.08,0,0,1,1.77-2Z",
    style: {
      opacity: 0.45,
      transformOrigin: "424.325px 298.975px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.28,307.26a3.5,3.5,0,0,1-.28,1.41l-1.89-1.08a3.72,3.72,0,0,0,2.14-2.87C451.27,305.54,451.28,307.17,451.28,307.26Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "450.195px 306.695px"
    },
    id: "elak8r64fzjor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbhfnd7sn20b"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "450.195px 306.695px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.28,307.26a3.5,3.5,0,0,1-.28,1.41l-1.89-1.08a3.72,3.72,0,0,0,2.14-2.87C451.27,305.54,451.28,307.17,451.28,307.26Z",
    id: "elgi68t2pqiw",
    className: "animable",
    style: {
      transformOrigin: "450.195px 306.695px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M451.27,308.84l-2.15-1.25a3.68,3.68,0,0,0,2.15-3.31,2.64,2.64,0,0,0,0-.29c-.09-1-.85-2-2.41-2.92h0a9.91,9.91,0,0,0-5-1.31h-.48l-.45,0-.39,0-.16,0-.3,0a18.67,18.67,0,0,0-2.43.51q-.58.15-1.14.33c-.55.17-1.08.35-1.58.52l-.6.2a17.86,17.86,0,0,1-3.35.95,3.07,3.07,0,0,1-2.11-.33c-.84-.49-1-1.23.61-2.14a5.52,5.52,0,0,1,4.85-.51l3.35-3.38a14.37,14.37,0,0,0-10.11.56l-2.8-1.6-3.8,2.19,2.79,1.61c-1.36,1-2.09,2.15-2.07,3.2v0c0,1.07.82,2.11,2.48,3.06,3.67,2.12,7.3,1.42,10.63.35,3.09-1,5.34-2.2,7.12-1.17,1.12.65.78,1.42-.46,2.14a6.16,6.16,0,0,1-5.32.31l-3.57,3.54a14.5,14.5,0,0,0,2,.58,13.53,13.53,0,0,0,3.44.25,15.69,15.69,0,0,0,5.39-1.32l2.79,1.62,3.77-2.18Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "437.465px 303.05px"
    },
    id: "el0fuhe7mjsb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld7k1d9r5kyn"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "437.465px 303.05px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.27,308.84l-2.15-1.25a3.68,3.68,0,0,0,2.15-3.31,2.64,2.64,0,0,0,0-.29c-.09-1-.85-2-2.41-2.92h0a9.91,9.91,0,0,0-5-1.31h-.48l-.45,0-.39,0-.16,0-.3,0a18.67,18.67,0,0,0-2.43.51q-.58.15-1.14.33c-.55.17-1.08.35-1.58.52l-.6.2a17.86,17.86,0,0,1-3.35.95,3.07,3.07,0,0,1-2.11-.33c-.84-.49-1-1.23.61-2.14a5.52,5.52,0,0,1,4.85-.51l3.35-3.38a14.37,14.37,0,0,0-10.11.56l-2.8-1.6-3.8,2.19,2.79,1.61c-1.36,1-2.09,2.15-2.07,3.2v0c0,1.07.82,2.11,2.48,3.06,3.67,2.12,7.3,1.42,10.63.35,3.09-1,5.34-2.2,7.12-1.17,1.12.65.78,1.42-.46,2.14a6.16,6.16,0,0,1-5.32.31l-3.57,3.54a14.5,14.5,0,0,0,2,.58,13.53,13.53,0,0,0,3.44.25,15.69,15.69,0,0,0,5.39-1.32l2.79,1.62,3.77-2.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "437.465px 303.05px"
    },
    id: "el6qi5ri74gqc",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "445.34 309.76 445.34 312.74 448.13 314.35 448.13 311.38 445.34 309.76",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "446.735px 312.055px"
    },
    id: "eluw8gbfvnmpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4q1sc02kdle"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "445.34 309.76 445.34 312.74 448.13 314.35 448.13 311.38 445.34 309.76",
    style: {
      opacity: 0.45,
      transformOrigin: "446.735px 312.055px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyjy5izeoah9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "422.94 297.18 426.74 294.99 429.54 296.59 426.77 295.43 422.94 297.18",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "426.24px 296.085px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltyqxu62g5wa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.45,299.92a5.52,5.52,0,0,1,4.85-.51l3.35-3.38-3.35,3A5.08,5.08,0,0,0,431.45,299.92Z",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "435.55px 297.975px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkh50u3ryv7l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.54,310.25a14.5,14.5,0,0,0,2,.58,13.53,13.53,0,0,0,3.44.25,12.09,12.09,0,0,1-4.84-1l3-3.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "437.26px 308.89px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ela36s32ewm34"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "445.34 309.76 448.13 311.02 451.9 309.2 448.13 311.38 445.34 309.76",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "448.62px 310.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxu4ilk2ut0r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.1,291c9.89-6,25.32-6.61,25.32-6.61-9.7,0-18.79,2.18-25.61,6.11-6.54,3.78-10.13,8.69-10.13,13.85C401.68,304.38,402,297.15,412.1,291Z",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "419.55px 294.37px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt1cvq2bos7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.54,325.9c10.51.46,21.28-1.62,29.32-6.26,8.35-4.82,11.92-11.36,10.72-17.65,0,0,1.56,10.25-11.35,17.27S434.54,325.9,434.54,325.9Z",
    style: {
      fill: "rgb(245, 245, 245)",
      opacity: 0.5,
      transformOrigin: "454.673px 313.976px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-75",
    className: "animable",
    style: {
      transformOrigin: "180.5px 222.927px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-75",
    className: "animable",
    style: {
      transformOrigin: "180.5px 222.927px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-75",
    className: "animable",
    style: {
      transformOrigin: "180.5px 222.927px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.07,422.13a5.43,5.43,0,0,1-2.47.75,6.16,6.16,0,0,1-3.62-.64A6.67,6.67,0,0,1,32,416.91l0-196,5.92,3.42v196c0,1.43.71,2.25,1.74,2.25A3.18,3.18,0,0,0,41.07,422.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "36.535px 321.92px"
    },
    id: "el4ziq16erm7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,252.21a6.92,6.92,0,0,1-3.14,5.45L41.07,422.13c-1.73,1-3.14.19-3.14-1.82V206.54l8.66-5c1.73-1,4.26-15.22,6-16.23l75.74-43.73c1.74-1,5.45,9.62,7.18,8.62L329,38.44V252.21Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "183.465px 230.499px"
    },
    id: "elappcbj76dg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.76,40.6V252.21a5.74,5.74,0,0,1-2.52,4.37L40.44,421.05a1.55,1.55,0,0,1-.77.26c-.43,0-.49-.62-.49-1v-213l8-4.64c1.19-.69,1.93-3,3.57-8.83.75-2.68,1.88-6.7,2.51-7.43l75.26-43.46a26.11,26.11,0,0,1,2.3,3.62c1.8,3.19,2.9,5,4.41,5a1.74,1.74,0,0,0,.87-.23L327.76,40.6M329,38.44,135.51,150.2a.54.54,0,0,1-.25.06c-1.72,0-4.94-8.75-6.68-8.75a.45.45,0,0,0-.25.07L52.59,185.31c-1.74,1-4.27,15.23-6,16.23l-8.66,5V420.31c0,1.43.71,2.25,1.74,2.25a2.85,2.85,0,0,0,1.4-.43L325.86,257.66a6.92,6.92,0,0,0,3.14-5.45V38.44Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "183.465px 230.5px"
    },
    id: "elnwuka4vwues",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,216.22A6.74,6.74,0,0,1,32,210.88V193.63a7,7,0,0,1,3.15-5.45L320,23.71a6.76,6.76,0,0,1,6.1-.11A6.7,6.7,0,0,1,329,28.93V46.19a6.92,6.92,0,0,1-3.14,5.45L41.07,216.11A6.76,6.76,0,0,1,35,216.22Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "180.5px 119.906px"
    },
    id: "elzytvpkbj0gb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwvmehbm8s0r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329,28.42c-.21-1.62-1.54-2.22-3.11-1.3L41.07,191.59a6.57,6.57,0,0,0-2.23,2.35l-5.9-3.42a6.53,6.53,0,0,1,2.23-2.34L320,23.72a6.68,6.68,0,0,1,6.09-.12A6.73,6.73,0,0,1,329,28.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "180.97px 108.432px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elume1k25zixl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.84,193.94a6.44,6.44,0,0,0-.91,3.1v27.27L32,220.89V193.63c0-.13,0-.25,0-.38,0-.29.07-.52.12-.78a7.27,7.27,0,0,1,.79-1.95Z",
    style: {
      opacity: 0.15,
      transformOrigin: "35.42px 207.415px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329,28.93v9.51L135.51,150.2,46.59,201.54l-8.66,5V197a7,7,0,0,1,3.14-5.45L325.86,27.12C327.59,26.11,329,26.93,329,28.93Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "183.465px 116.614px"
    },
    id: "eljhxulb1xeol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.13,34.24c1.23-.71,2.24-.14,2.24,1.29a5,5,0,0,1-2.24,3.88c-1.24.71-2.24.13-2.24-1.29A4.94,4.94,0,0,1,321.13,34.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "321.13px 36.8241px"
    },
    id: "elxt8h70u9vro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07,38.88c1.24-.71,2.24-.13,2.24,1.3a4.93,4.93,0,0,1-2.24,3.87c-1.23.72-2.24.14-2.24-1.29A5,5,0,0,1,313.07,38.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.07px 41.4682px"
    },
    id: "el7pgemh6hv4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,43.53c1.24-.71,2.24-.14,2.24,1.29A5,5,0,0,1,305,48.7c-1.23.71-2.23.13-2.23-1.29A5,5,0,0,1,305,43.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "305.005px 46.1141px"
    },
    id: "elb4mk44ttm0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4,202.79c1.06-.61,1.42-1.55,1.93-3.35l1.17-4c.42-1.63.86-2.74,1.94-3.35L96,165.16c1.07-.62,1.91-.69,2.73.66l1.41,2.61c.61,1,.91,1.66,2,1l36.15-20.87L329,38.44V56.2L37.93,224.31V206.54l6.47-3.75",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "183.465px 131.375px"
    },
    id: "elqoamn6xs33m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.93 206.54 37.93 224.31 32.01 220.89 32.01 203.14 37.93 206.54",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "34.97px 213.725px"
    },
    id: "elv9mvt3xudgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1khguivbf7w"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "37.93 206.54 37.93 224.31 32.01 220.89 32.01 203.14 37.93 206.54",
    style: {
      opacity: 0.15,
      transformOrigin: "34.97px 213.725px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcotjgjkyda4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49,208.09l-3.64,2.09,1.39-2.66a.65.65,0,0,0,0-.65c-.1-.13-.29,0-.41.19l-2,3.8h0s0,.09,0,.14,0,0,0,.05a.63.63,0,0,0,0,.19.43.43,0,0,0,0,.17s0,0,0,0a.56.56,0,0,0,0,.08h0l2,1.52a.17.17,0,0,0,.19,0,.59.59,0,0,0,.22-.28c.11-.25.1-.53,0-.62l-1.39-1.07L49,209a.78.78,0,0,0,.29-.62C49.24,208.12,49.11,208,49,208.09Z",
    style: {
      opacity: 0.3,
      transformOrigin: "46.8108px 209.928px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6aywv6xalor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,206.33l3.64-2.1-1.39-1.06c-.12-.09-.13-.37,0-.62s.29-.37.41-.28l2,1.52h0l.06.08s0,0,0,0a.43.43,0,0,1,0,.17.63.63,0,0,1,0,.19s0,0,0,.05l-.06.14h0l-2,3.8a.52.52,0,0,1-.19.22.16.16,0,0,1-.22,0,.69.69,0,0,1,0-.65l1.39-2.67L52,207.23c-.16.1-.29,0-.29-.28A.78.78,0,0,1,52,206.33Z",
    style: {
      opacity: 0.3,
      transformOrigin: "54.2192px 205.362px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el054s72px7syv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9,195.87c0-.22-.21-.19-.31,0l-.49,1.22c-.85-.09-1.88.74-2.58,2.21-.9,1.9-.9,4.16,0,5a1.29,1.29,0,0,0,1.64.1,4.46,4.46,0,0,0,1.63-2,.65.65,0,0,0,0-.64c-.12-.11-.3,0-.41.24-.68,1.42-1.77,2.06-2.44,1.41s-.67-2.33,0-3.75c.48-1,1.16-1.62,1.76-1.65l-.37.91c-.1.24,0,.46.14.36l1.49-1a.48.48,0,0,0,.16-.41Z",
    style: {
      opacity: 0.3,
      transformOrigin: "61.9838px 200.182px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqwusx2a62ub"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.58,169.92l1.11-2.34a.72.72,0,0,0,0-.73c-.13-.13-.34,0-.47.27l-1.11,2.34L95,168.4c-.13-.13-.34,0-.47.27a.72.72,0,0,0,0,.73l1.1,1.07-1.1,2.34a.72.72,0,0,0,0,.73.19.19,0,0,0,.23,0,.6.6,0,0,0,.24-.29l1.11-2.35L97.22,172a.18.18,0,0,0,.23,0,.68.68,0,0,0,.24-.28.72.72,0,0,0,0-.73Z",
    style: {
      opacity: 0.3,
      transformOrigin: "96.11px 170.189px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.15,198.69v-4.23a4.61,4.61,0,0,1,2.09-3.61L313.8,51.25c1.15-.67,2.09-.13,2.09,1.21v4.22a4.64,4.64,0,0,1-2.09,3.62L72.24,199.9C71.09,200.56,70.15,200,70.15,198.69Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "193.02px 125.57px"
    },
    id: "elfn2s89oga0v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,60.62a.58.58,0,0,1-.19,0,.58.58,0,0,1-.31-.64l.2-1.71-.8-.58a.56.56,0,0,1-.22-.47.94.94,0,0,1,.34-.73l1.23-.94a.22.22,0,0,0,.05-.1l.55-1.8a.76.76,0,0,1,.62-.58.48.48,0,0,1,.48.29l.46,1,1-.4A.48.48,0,0,1,315,54a.75.75,0,0,1,0,.84l-.89,1.67a.33.33,0,0,0,0,.1l.21,1.51a1,1,0,0,1-.26.75.6.6,0,0,1-.49.19l-1-.13-1.08,1.39A.65.65,0,0,1,311,60.62Zm-.59-3.48.8.57a.62.62,0,0,1,.22.58l-.14,1.14.72-.92a.63.63,0,0,1,.55-.27l1,.13s0-.09,0-.11l-.21-1.51a.94.94,0,0,1,.11-.54l.78-1.46-.8.31a.51.51,0,0,1-.64-.26l-.36-.77-.49,1.6a.87.87,0,0,1-.3.46l-1.23.95S310.38,57.1,310.37,57.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "312.404px 56.8481px"
    },
    id: "elyju8zi715k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elerxrxtm8mem"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "321.293px 51.7114px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.35,50.73a.72.72,0,0,1-.36-1.35L323.87,46a.72.72,0,1,1,.72,1.25l-5.88,3.4A.77.77,0,0,1,318.35,50.73Z",
    id: "eljznok463h4s",
    className: "animable",
    style: {
      transformOrigin: "321.286px 48.3165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.35,54.13a.72.72,0,0,1-.36-1.35l5.88-3.39a.71.71,0,0,1,1,.26.73.73,0,0,1-.27,1L318.71,54A.68.68,0,0,1,318.35,54.13Z",
    id: "elirjp55o3ab",
    className: "animable",
    style: {
      transformOrigin: "321.293px 51.7057px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.35,57.52a.72.72,0,0,1-.36-1.35l5.88-3.39a.72.72,0,1,1,.72,1.25l-5.88,3.4A.77.77,0,0,1,318.35,57.52Z",
    id: "elhsihy6c5iim",
    className: "animable",
    style: {
      transformOrigin: "321.285px 55.1019px"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M203.85,138.74,185.08,149.6a3.16,3.16,0,0,0-1.47,2.44c0,.88.66,1.22,1.47.75l18.77-10.86a3.16,3.16,0,0,0,1.47-2.44C205.32,138.6,204.66,138.27,203.85,138.74Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "194.465px 145.764px"
    },
    id: "elvbp0eumq3pf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75,122.65,217,131.18a3.16,3.16,0,0,0-1.47,2.44c0,.89.66,1.22,1.47.75l14.77-8.53a3.14,3.14,0,0,0,1.48-2.44C233.23,122.52,232.57,122.18,231.75,122.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.39px 128.511px"
    },
    id: "elxyq0r39clzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.15,108l-12.26,7.08a3.14,3.14,0,0,0-1.48,2.45c0,.88.66,1.21,1.48.74l12.26-7.08a3.16,3.16,0,0,0,1.47-2.44C258.62,107.87,258,107.54,257.15,108Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "251.015px 113.138px"
    },
    id: "elzxscq92y1ad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.05,89.59l-18.77,10.86a3.16,3.16,0,0,0-1.47,2.44c0,.89.66,1.22,1.47.75l18.77-10.86a3.16,3.16,0,0,0,1.47-2.44C290.52,89.46,289.86,89.12,289.05,89.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "279.665px 96.616px"
    },
    id: "eldey60576u5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.93 335.3 329 167.26 329 79.49 37.93 247.53 37.93 335.3",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "183.465px 207.395px"
    },
    id: "elfxt5in7jjn5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,266.61a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.64l96.35-55.62a.47.47,0,0,1,.64.17.47.47,0,0,1-.17.64L81.81,266.54A.39.39,0,0,1,81.58,266.61Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "129.75px 238.329px"
    },
    id: "eluswwq0tk66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,272.46a.48.48,0,0,1-.41-.23.47.47,0,0,1,.17-.64l35.5-20.49a.46.46,0,0,1,.64.17.47.47,0,0,1-.17.64L81.81,272.4A.46.46,0,0,1,81.58,272.46Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "99.325px 261.747px"
    },
    id: "el0of5u05big5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.14,249a.46.46,0,0,1-.4-.23.47.47,0,0,1,.17-.64l20.28-11.71a.47.47,0,1,1,.47.81L122.38,249A.53.53,0,0,1,122.14,249Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "132.304px 242.674px"
    },
    id: "el0c4paz6pfy2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44,234.44a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.64L177.69,216a.48.48,0,0,1,.64.17.47.47,0,0,1-.17.64l-30.49,17.61A.46.46,0,0,1,147.44,234.44Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "162.68px 225.194px"
    },
    id: "elp5sdcurf27m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,278.32a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.64l15.22-8.78a.47.47,0,1,1,.46.81l-15.21,8.79A.46.46,0,0,1,81.58,278.32Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "89.2111px 273.442px"
    },
    id: "el4lb25acipk9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.86,266.61a.49.49,0,0,1-.41-.24.47.47,0,0,1,.18-.64l35.49-20.49a.47.47,0,0,1,.64.17.46.46,0,0,1-.17.64l-35.5,20.49A.39.39,0,0,1,101.86,266.61Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "119.608px 255.894px"
    },
    id: "eliv97pbw2vn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43,243.19a.47.47,0,0,1-.24-.88l35.5-20.49a.47.47,0,0,1,.47.81l-35.5,20.49A.39.39,0,0,1,142.43,243.19Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "160.155px 232.483px"
    },
    id: "eln3oviazjli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,284.17a.48.48,0,0,1-.41-.23.47.47,0,0,1,.17-.64l96.35-55.63a.48.48,0,0,1,.64.18.47.47,0,0,1-.17.64L81.81,284.11A.46.46,0,0,1,81.58,284.17Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "129.75px 255.892px"
    },
    id: "el0l2su8kz39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,290a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.64l35.5-20.49a.48.48,0,0,1,.64.17.47.47,0,0,1-.17.64L81.81,290A.46.46,0,0,1,81.58,290Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "99.325px 279.293px"
    },
    id: "elrz980jl8xbf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.14,266.61a.47.47,0,0,1-.23-.88L142.19,254a.48.48,0,0,1,.64.17.46.46,0,0,1-.17.64l-20.28,11.71A.44.44,0,0,1,122.14,266.61Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "132.283px 260.275px"
    },
    id: "elfzw9jktjg4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44,252a.48.48,0,0,1-.41-.23.47.47,0,0,1,.17-.64l30.49-17.6a.47.47,0,0,1,.64.17.47.47,0,0,1-.17.64l-30.49,17.6A.46.46,0,0,1,147.44,252Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "162.68px 242.734px"
    },
    id: "elwo9end8imm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,295.88a.48.48,0,0,1-.41-.23.47.47,0,0,1,.17-.64l15.22-8.78a.47.47,0,0,1,.64.17A.48.48,0,0,1,97,287l-15.21,8.78A.46.46,0,0,1,81.58,295.88Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "89.1724px 291.024px"
    },
    id: "elrufjk2pwawp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.86,284.17a.48.48,0,0,1-.41-.23.47.47,0,0,1,.18-.64l35.49-20.5a.47.47,0,0,1,.64.18.46.46,0,0,1-.17.64l-35.5,20.49A.46.46,0,0,1,101.86,284.17Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "119.608px 273.455px"
    },
    id: "elh69vtcubbk4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43,260.75a.47.47,0,0,1-.24-.87l35.5-20.5a.47.47,0,0,1,.47.82l-35.5,20.49A.46.46,0,0,1,142.43,260.75Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "160.182px 250.034px"
    },
    id: "ely774uahhed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,235.58a1.57,1.57,0,0,1,1.23.87,4.47,4.47,0,0,1,.43,2.16,8.15,8.15,0,0,1-.43,2.66,7.84,7.84,0,0,1-1.23,2.28,6.72,6.72,0,0,1-1.89,1.64L85,246v3.21l-2.25,1.3V238.22l3.64-2.1A3.18,3.18,0,0,1,88.3,235.58Zm-1,5.88a3.32,3.32,0,0,0,.35-1.53,1.41,1.41,0,0,0-.35-1.13c-.24-.18-.59-.14-1,.13l-1.26.73v3.59l1.26-.72A2.76,2.76,0,0,0,87.33,241.46Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "86.3581px 243.044px"
    },
    id: "elsvt2jr5ytqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.54,240.44l-1.23.71v3.27l-2.26,1.3V233.44l3.65-2.11a3.13,3.13,0,0,1,1.88-.53,1.57,1.57,0,0,1,1.23.87,4.44,4.44,0,0,1,.43,2.16,8.11,8.11,0,0,1-.4,2.56,7.58,7.58,0,0,1-1.16,2.22l1.72,2.86L96,242.87ZM95.61,234c-.23-.18-.58-.14-1,.13l-1.25.72v3.6l1.25-.73a2.52,2.52,0,0,0,1-1.07,3.14,3.14,0,0,0,.36-1.53A1.35,1.35,0,0,0,95.61,234Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "94.725px 238.259px"
    },
    id: "elvs9l6fmkjr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.49,228.57l2.25-1.3v12.28l-2.25,1.3Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "100.615px 234.06px"
    },
    id: "elu6py333f45k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.08,237.05a2.36,2.36,0,0,1-1.57-1.37,6.58,6.58,0,0,1-.57-3,11.87,11.87,0,0,1,.57-3.63,11.24,11.24,0,0,1,1.57-3.18,7.1,7.1,0,0,1,2.25-2.11,3.28,3.28,0,0,1,2-.55,2,2,0,0,1,1.46.88L109.32,227a1.3,1.3,0,0,0-1.88-.35,3.63,3.63,0,0,0-1.15,1.1,5.72,5.72,0,0,0-.79,1.69,7.05,7.05,0,0,0-.28,2,4.12,4.12,0,0,0,.28,1.67,1.26,1.26,0,0,0,.79.79,1.5,1.5,0,0,0,1.15-.23,4.93,4.93,0,0,0,1.88-2.53l1.44,1.17a9.78,9.78,0,0,1-1.46,2.56,6.85,6.85,0,0,1-2,1.74A3.08,3.08,0,0,1,105.08,237.05Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "106.861px 230.153px"
    },
    id: "elk2g0d2x0689",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.76,221.48l2.26-1.3v12.28l-2.26,1.3Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "112.89px 226.97px"
    },
    id: "el0tpcw5c5n8d9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.22,214.87v12.28l-1.86,1.07-3.52-4.51v6.55l-2.22,1.27V219.25l1.86-1.07,3.52,4.51v-6.55Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "119.42px 223.2px"
    },
    id: "el22t0nf4zkzy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,216.74l2-1.15v5.09a11.54,11.54,0,0,1-1.57,2.06,8.52,8.52,0,0,1-1.78,1.43,3.06,3.06,0,0,1-2.26.49A2.37,2.37,0,0,1,125,223.3a6.66,6.66,0,0,1-.57-3,11.87,11.87,0,0,1,.57-3.63,11.46,11.46,0,0,1,1.58-3.19,7.47,7.47,0,0,1,2.3-2.14,3.57,3.57,0,0,1,2-.58,2,2,0,0,1,1.48.82l-1.43,2.82a1.41,1.41,0,0,0-1.94-.25,4.18,4.18,0,0,0-1.65,1.91,6.71,6.71,0,0,0-.63,2.92,4,4,0,0,0,.28,1.65,1.32,1.32,0,0,0,.8.79,1.54,1.54,0,0,0,1.18-.23,4.16,4.16,0,0,0,1.21-1.11Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "128.392px 217.733px"
    },
    id: "eltvvvfd8ji5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.69,204.75a3,3,0,0,1,.87,2.58,7.41,7.41,0,0,1-.87,3.58,6.19,6.19,0,0,1-2.39,2.5l-2.14,1.24v3.88l-.85.48V206.73l3-1.72C141.32,204.42,142.11,204.33,142.69,204.75Zm-.6,5.69a5.4,5.4,0,0,0,.63-2.62c0-1-.21-1.64-.63-1.93s-1-.2-1.81.25l-2.12,1.23v6.14l2.12-1.23A4.64,4.64,0,0,0,142.09,210.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "140.451px 211.75px"
    },
    id: "eldgp4eg1zgjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,202.07l.84-.49v11.16l4.47-2.58v1.13l-5.31,3.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "148.035px 207.965px"
    },
    id: "el5fcsai9qtip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.12,204.3l-4.44,2.56-1,3.84-.88.5,3.65-14.39.83-.48L159,206.51l-.89.51Zm-.31-.88-1.91-5.49-1.92,7.7Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "154.9px 203.765px"
    },
    id: "elwj02t6w6k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,189.62V201.9l-.69.4-5.13-7v10l-.84.49V193.47l.69-.41,5.14,7v-10Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "163.67px 197.705px"
    },
    id: "elyhmccpt971s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.05,199.78a1.58,1.58,0,0,1-1.26-.43l.33-1.19a1.62,1.62,0,0,0,1.15.41,3,3,0,0,0,1.48-.44,4.27,4.27,0,0,0,1.61-1.54,3.62,3.62,0,0,0,.53-1.87,1.33,1.33,0,0,0-.29-1,1,1,0,0,0-.71-.27,7.67,7.67,0,0,0-1.17.16,6.72,6.72,0,0,1-1.44.16,1.21,1.21,0,0,1-.91-.47,2.41,2.41,0,0,1-.39-1.58,5.91,5.91,0,0,1,1.3-3.66,5.75,5.75,0,0,1,1.64-1.41,3.81,3.81,0,0,1,1.34-.48,2,2,0,0,1,1.14.14l-.29,1.2a2,2,0,0,0-1.07-.14,3.06,3.06,0,0,0-1.12.39,4.06,4.06,0,0,0-1.57,1.53,3.75,3.75,0,0,0-.53,1.91,1.38,1.38,0,0,0,.29,1,1,1,0,0,0,.73.26,7.62,7.62,0,0,0,1.18-.16,6.35,6.35,0,0,1,1.41-.16,1.22,1.22,0,0,1,.92.45,2.45,2.45,0,0,1,.38,1.56,5.79,5.79,0,0,1-.33,1.89,5.93,5.93,0,0,1-1,1.78,5.65,5.65,0,0,1-1.66,1.4A3.61,3.61,0,0,1,170.05,199.78Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "171.766px 192.965px"
    },
    id: "el2bl7zjc2ipu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.93,112.44V178a4.58,4.58,0,0,1-2.05,3.55L187.45,240.35a1.89,1.89,0,0,1-.35.17h0c-1,.37-1.69-.18-1.69-1.34V173.63a4.29,4.29,0,0,1,.59-2,4.2,4.2,0,0,1,1.45-1.53l101.44-58.84c.94-.54,1.74-.26,2,.61a.57.57,0,0,0,0-.18,2.26,2.26,0,0,1,.08.44C290.92,112.23,290.93,112.34,290.93,112.44Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "238.19px 175.809px"
    },
    id: "eltm2w5vhgvyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.13 230.98 285.2 176.64 285.2 160.82 259.7 156.68 241.63 178.74 246.54 184.28 217.51 166.71 191.13 209.56 191.13 230.98",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "238.165px 193.83px"
    },
    id: "elkv0e8p05pbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.25,130.07c2.79-1.64,5.06-.35,5.05,2.88a11.21,11.21,0,0,1-5.08,8.77c-2.79,1.61-5.06.33-5.05-2.88A11.28,11.28,0,0,1,275.25,130.07Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "275.235px 135.887px"
    },
    id: "elvsnnb0vljli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,294.9l0,49.19a3.32,3.32,0,0,1-1.48,2.57L83.5,378.31a1.92,1.92,0,0,1-.25.12h0c-.7.27-1.22-.13-1.22-1V328.21a3.26,3.26,0,0,1,1.47-2.55L138.32,294c.68-.39,1.26-.18,1.43.44a.5.5,0,0,0,0-.12,1.7,1.7,0,0,1,.06.31C139.79,294.74,139.8,294.82,139.8,294.9Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "110.92px 336.158px"
    },
    id: "elb68ytnet2pg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.15 371.53 135.66 342.95 135.66 330.1 124.98 323.77 114.71 338.75 117.79 342.73 99.1 329.25 86.15 355.31 86.15 371.53",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "110.905px 347.65px"
    },
    id: "elvirbrpuowna",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.27,313.68c2-1.21,3.66-.26,3.65,2.13a8.32,8.32,0,0,1-3.66,6.49c-2,1.2-3.66.24-3.66-2.13A8.44,8.44,0,0,1,116.27,313.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "116.26px 317.986px"
    },
    id: "elsp9ou4114nr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.88,207.67l.05,49.2a3.29,3.29,0,0,1-1.48,2.56l-54.87,31.65a1.92,1.92,0,0,1-.25.12h0c-.7.27-1.22-.13-1.22-1V241a3.14,3.14,0,0,1,.43-1.45,3,3,0,0,1,1-1.1l54.83-31.62c.68-.39,1.26-.19,1.43.44a.27.27,0,0,0,0-.13,1.7,1.7,0,0,1,.06.31A2,2,0,0,1,290.88,207.67Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "262.02px 248.957px"
    },
    id: "eledd3wj6ca45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.24 284.3 286.75 255.72 286.75 242.87 276.06 236.54 265.79 251.52 268.87 255.5 250.18 242.03 237.24 268.08 237.24 284.3",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "261.995px 260.42px"
    },
    id: "el03xs392c26j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.35,226.46c2-1.22,3.66-.26,3.65,2.12a8.32,8.32,0,0,1-3.66,6.49c-2,1.2-3.66.25-3.65-2.12A8.38,8.38,0,0,1,267.35,226.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.345px 230.76px"
    },
    id: "elc664x9luep5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.34,251.29l0,49.2a3.3,3.3,0,0,1-1.48,2.56L159,334.7a1.92,1.92,0,0,1-.25.12h0c-.7.27-1.22-.13-1.22-1V284.6a3.26,3.26,0,0,1,1.47-2.55l54.83-31.62c.68-.39,1.26-.19,1.43.43a.25.25,0,0,0,0-.12,1.7,1.7,0,0,1,.06.31C215.33,251.14,215.34,251.21,215.34,251.29Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "186.435px 292.567px"
    },
    id: "elb1o8icgn7ra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.69 327.92 211.2 299.34 211.21 286.49 200.52 280.16 190.25 295.14 193.33 299.12 174.64 285.64 161.69 311.7 161.69 327.92",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "186.45px 304.04px"
    },
    id: "el3t9vgkc90tt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.81,270.07c2-1.21,3.66-.26,3.65,2.13a8.32,8.32,0,0,1-3.66,6.49c-2,1.2-3.66.24-3.65-2.13A8.4,8.4,0,0,1,191.81,270.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "191.805px 274.376px"
    },
    id: "elzvwdc7dax5o",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--premium-option--inject-75",
    className: "animable",
    style: {
      transformOrigin: "347.955px 201.009px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-75",
    className: "animable",
    style: {
      transformOrigin: "347.955px 201.009px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-75",
    className: "animable",
    style: {
      transformOrigin: "347.955px 201.009px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.23,301.82a5.07,5.07,0,0,0,2.31,4l1.88,1.09a5.12,5.12,0,0,0,4.22.19c-1.08.42-1.91-.21-1.91-1.52V150.41a4.82,4.82,0,0,1,.67-2.28l-6.5-3.75a4.82,4.82,0,0,0-.67,2.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.435px 225.923px"
    },
    id: "elz1blxlwthol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.71,306.46l-.3.15h0l-.09,0a1.12,1.12,0,0,1-.35.06c-.54,0-.62-.62-.62-1V150.53a4,4,0,0,1,.6-1.95,3.85,3.85,0,0,1,1.38-1.49l82.37-47.55a1.5,1.5,0,0,1,.71-.23c.12,0,.42,0,.56.51a2.63,2.63,0,0,1,.06.49V255.47c0,1.42,0,2.28-1.77,3.28Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "351.19px 202.99px"
    },
    id: "elxyqt43sp9va",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05,100.31v40.84l-85.68,49.47V150.53a4.09,4.09,0,0,1,.59-1.95,4.19,4.19,0,0,1,1.39-1.49l82.37-47.55a1.5,1.5,0,0,1,.71-.23c.12,0,.42,0,.55.51A2,2,0,0,1,394.05,100.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "351.21px 144.965px"
    },
    id: "elivbspccqo4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.55,158a3.58,3.58,0,0,1,1.29-.5,1.34,1.34,0,0,1,1,.2,1.7,1.7,0,0,1,.62.91,5,5,0,0,1,.22,1.64,7.76,7.76,0,0,1-.22,1.91,6.3,6.3,0,0,1-1.6,2.95,5.72,5.72,0,0,1-1.29,1l-1.44.84v3.53a.92.92,0,0,1-.09.38.63.63,0,0,1-.21.26l-1.48.85a.15.15,0,0,1-.21,0,.35.35,0,0,1-.09-.27V160.52a.92.92,0,0,1,.09-.39.63.63,0,0,1,.21-.26Zm-1.44,6.25,1.38-.8a2.13,2.13,0,0,0,.78-.77,2.27,2.27,0,0,0,.31-1.23c0-.49-.1-.77-.31-.87a.87.87,0,0,0-.78.13l-1.38.8Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "327.366px 164.744px"
    },
    id: "elmkehhad8qo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.94,153.17a4.22,4.22,0,0,1,1.32-.52,1.5,1.5,0,0,1,1,.15,1.64,1.64,0,0,1,.63.88,5.21,5.21,0,0,1,.22,1.63,7.53,7.53,0,0,1-.35,2.35,5.92,5.92,0,0,1-1,1.88l1.39,3.32a.47.47,0,0,1,0,.17.75.75,0,0,1-.08.31.46.46,0,0,1-.17.21l-1.53.88c-.15.09-.26.1-.32,0a.66.66,0,0,1-.15-.22l-1.25-3-1,.59v3.71a.92.92,0,0,1-.09.38.73.73,0,0,1-.22.26l-1.47.85a.15.15,0,0,1-.21,0,.35.35,0,0,1-.09-.27V155.58a.85.85,0,0,1,.09-.38.61.61,0,0,1,.21-.27Zm-1.27,6,1.27-.73a2.47,2.47,0,0,0,.78-.73,2.11,2.11,0,0,0,.31-1.18c0-.49-.11-.76-.31-.83a1,1,0,0,0-.78.18l-1.27.73Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "335.863px 159.832px"
    },
    id: "elibjcsjttfd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.87,156.21a.17.17,0,0,1,.22,0,.38.38,0,0,1,.09.28v1.83a.85.85,0,0,1-.09.38.56.56,0,0,1-.22.27l-5.33,3.07a.16.16,0,0,1-.21,0,.38.38,0,0,1-.09-.28V150.58a.88.88,0,0,1,.09-.38.52.52,0,0,1,.21-.26l5.24-3a.17.17,0,0,1,.22,0,.35.35,0,0,1,.09.27V149a.88.88,0,0,1-.09.38.53.53,0,0,1-.22.26l-3.46,2v1.87l3.22-1.86a.15.15,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.83a.88.88,0,0,1-.09.38.57.57,0,0,1-.21.26l-3.22,1.86v1.94Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "344.21px 154.489px"
    },
    id: "el292aj5wnkch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,152.61a.9.9,0,0,1-.15-.19l-1.06-2.25v5.73a.88.88,0,0,1-.09.38.57.57,0,0,1-.21.26l-1.47.85a.18.18,0,0,1-.22,0,.38.38,0,0,1-.09-.28V145.92a.85.85,0,0,1,.09-.38.53.53,0,0,1,.22-.26l1.3-.76c.15-.08.26-.09.34,0a1.08,1.08,0,0,1,.14.19l1.83,3.74,1.82-5.84c0-.07.07-.19.14-.36a.87.87,0,0,1,.34-.39l1.31-.75a.16.16,0,0,1,.21,0,.38.38,0,0,1,.09.28v11.18a.85.85,0,0,1-.09.38.52.52,0,0,1-.21.26l-1.48.85a.15.15,0,0,1-.21,0,.38.38,0,0,1-.09-.28v-5.73L354,151.52c0,.11-.09.24-.15.37a.6.6,0,0,1-.26.3l-.72.42C352.75,152.67,352.67,152.67,352.6,152.61Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "353.225px 149.249px"
    },
    id: "elz1j2wc23znh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.86,151.48a.15.15,0,0,1-.21,0,.35.35,0,0,1-.09-.27V140a.92.92,0,0,1,.09-.39.63.63,0,0,1,.21-.26l1.47-.85a.18.18,0,0,1,.22,0,.37.37,0,0,1,.09.27V150a.92.92,0,0,1-.09.39.65.65,0,0,1-.22.26Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "360.6px 144.993px"
    },
    id: "el8wqv7m38ugc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.51,133.22a.15.15,0,0,1,.21,0,.38.38,0,0,1,.09.28v6.9a9.66,9.66,0,0,1-.25,2.26,8.25,8.25,0,0,1-.7,1.94,6.65,6.65,0,0,1-1.09,1.57,5.8,5.8,0,0,1-1.38,1.12,3.24,3.24,0,0,1-1.39.49,1.5,1.5,0,0,1-1.08-.32,2.4,2.4,0,0,1-.7-1.14,6.75,6.75,0,0,1-.25-2v-6.9a.92.92,0,0,1,.09-.39.58.58,0,0,1,.22-.26l1.47-.85a.15.15,0,0,1,.21,0,.37.37,0,0,1,.09.27v6.84a2.27,2.27,0,0,0,.34,1.44c.22.26.55.26,1,0a2.38,2.38,0,0,0,1-1.17,4.6,4.6,0,0,0,.33-1.81v-6.84a.88.88,0,0,1,.09-.38.52.52,0,0,1,.21-.26Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "367.39px 140.482px"
    },
    id: "el68gi2vyajd2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.44,138.85a.62.62,0,0,1-.16-.2l-1-2.24v5.73a.88.88,0,0,1-.09.38.53.53,0,0,1-.22.26l-1.47.85a.16.16,0,0,1-.21,0,.38.38,0,0,1-.09-.28V132.16a.85.85,0,0,1,.09-.38.52.52,0,0,1,.21-.26l1.31-.76c.15-.08.26-.09.33,0a.84.84,0,0,1,.15.19l1.82,3.74,1.82-5.84a2.85,2.85,0,0,1,.15-.36.79.79,0,0,1,.33-.39l1.31-.75a.16.16,0,0,1,.21,0,.38.38,0,0,1,.09.28v11.18a.85.85,0,0,1-.09.38.52.52,0,0,1-.21.26l-1.47.85a.17.17,0,0,1-.22,0,.38.38,0,0,1-.09-.28v-5.73l-1.05,3.47a2.76,2.76,0,0,1-.16.37.6.6,0,0,1-.26.3l-.72.42C376.59,138.91,376.5,138.91,376.44,138.85Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "377.11px 135.49px"
    },
    id: "ele3c2h9eytvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.38 127.38 353.42 129.6 355.76 128.7 354.07 131.87 354.47 134.74 352.38 134.48 350.29 137.15 350.69 133.82 349 132.6 351.34 130.8 352.38 127.38",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "352.38px 132.265px"
    },
    id: "elvwouemfow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.43 134.66 347.22 136.35 349 135.67 347.71 138.08 348.02 140.27 346.43 140.08 344.83 142.11 345.14 139.57 343.85 138.64 345.63 137.27 346.43 134.66",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "346.425px 138.385px"
    },
    id: "elpqo6kxfnbf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.43 129.14 359.23 130.84 361.01 130.15 359.72 132.57 360.03 134.76 358.43 134.56 356.84 136.6 357.14 134.06 355.86 133.13 357.64 131.75 358.43 129.14",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "358.435px 132.87px"
    },
    id: "elzynx6igjczk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.35,99.86a1.29,1.29,0,0,1,0,.33V255.36c0,1.34,0,1.89-1.21,2.69l-82.59,47.72a1.37,1.37,0,0,0-.41.11h-.05l-.06,0a1.25,1.25,0,0,1,0-.34V150.41a3.56,3.56,0,0,1,.51-1.64,3.25,3.25,0,0,1,1.14-1.23L393.05,100a1.46,1.46,0,0,1,.3-.13m.08-1.32a2,2,0,0,0-1,.32L310,146.41a4.57,4.57,0,0,0-1.62,1.72,4.73,4.73,0,0,0-.68,2.28V305.57c0,1.06.52,1.66,1.27,1.66a1.66,1.66,0,0,0,.56-.1.13.13,0,0,0,.08,0,2.5,2.5,0,0,0,.41-.19l82.57-47.71c2.08-1.18,2.09-2.37,2.09-3.84V100.19a3,3,0,0,0-.08-.65,1.21,1.21,0,0,0-1.19-1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "351.19px 202.885px"
    },
    id: "elx1ur66kwqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.63,99.53c-.27-1-1.17-1.29-2.23-.68L310,146.41a4.52,4.52,0,0,0-1.63,1.72l-6.5-3.75a4.59,4.59,0,0,1,1.63-1.72L385.89,95.1a5.15,5.15,0,0,1,4.62,0l1.89,1.09A5.16,5.16,0,0,1,394.63,99.53Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "348.25px 121.341px"
    },
    id: "elxbxid8zy6ii",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333,244.67a.55.55,0,0,1-.48-.28.54.54,0,0,1,.2-.74l48.84-28.18a.55.55,0,1,1,.55.95l-48.84,28.17A.56.56,0,0,1,333,244.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "357.431px 230.024px"
    },
    id: "eliqjl3p3zyn8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,249.39a.56.56,0,0,1-.48-.27.55.55,0,0,1,.2-.75l48.84-28.18a.55.55,0,1,1,.55.95l-48.84,28.18A.54.54,0,0,1,333,249.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "357.431px 234.744px"
    },
    id: "elshyhlkabvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,257a.56.56,0,0,1-.27-.08.52.52,0,0,1-.27-.47v-6.47a.53.53,0,0,1,.27-.47l5.58-3.23a.59.59,0,0,1,.55,0,.55.55,0,0,1,.27.48v6.47a.55.55,0,0,1-.27.47l-5.58,3.22A.57.57,0,0,1,320.54,257Zm.55-6.7v5.2l4.49-2.59v-5.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "323.335px 251.606px"
    },
    id: "elyfxke2k5p0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.59,253.26a.51.51,0,0,1-.37-.15l-1.49-1.41a.55.55,0,0,1,.75-.8l.93.88,2.69-6a.55.55,0,0,1,.72-.28.56.56,0,0,1,.28.73l-3,6.73a.54.54,0,0,1-.39.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "324.366px 249.362px"
    },
    id: "elwihyx6l516e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,258.52a.54.54,0,0,1-.48-.27.55.55,0,0,1,.2-.75l48.84-28.17a.53.53,0,0,1,.75.2.54.54,0,0,1-.2.74l-48.84,28.18A.54.54,0,0,1,333,258.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "357.415px 243.884px"
    },
    id: "ele363u60en9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,263.25a.55.55,0,0,1-.28-1l48.84-28.17a.55.55,0,0,1,.55.95l-48.84,28.17A.56.56,0,0,1,333,263.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "357.42px 248.637px"
    },
    id: "elfo6f9dereb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,270.81a.53.53,0,0,1-.54-.54V263.8a.55.55,0,0,1,.27-.48l5.58-3.22a.55.55,0,0,1,.82.47V267a.55.55,0,0,1-.27.48l-5.58,3.22A.55.55,0,0,1,320.54,270.81Zm.55-6.7v5.21l4.49-2.59v-5.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "323.335px 265.42px"
    },
    id: "el95evyyoeuw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.59,267.12a.56.56,0,0,1-.37-.15l-1.49-1.42a.54.54,0,0,1,.75-.79l.93.88,2.69-6a.55.55,0,0,1,1,.45l-3,6.73a.55.55,0,0,1-.39.32Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "324.347px 263.247px"
    },
    id: "el3vnr6qafb3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.79,268.89l28.84-16.65c1.67-1,3-.19,3,1.74v4.46a6.65,6.65,0,0,1-3,5.22l-28.84,16.66c-1.67,1-3,.18-3-1.74v-4.47A6.65,6.65,0,0,1,336.79,268.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "351.21px 266.279px"
    },
    id: "el4qsoydvex8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,269.23a1.33,1.33,0,0,1,.59-.2,1,1,0,0,1,.44.09.75.75,0,0,1,.28.28,1,1,0,0,1,.1.36.22.22,0,0,1,0,.13.21.21,0,0,1-.08.1l-.23.13a.11.11,0,0,1-.1,0,.14.14,0,0,1-.07-.09.5.5,0,0,0-.1-.13.37.37,0,0,0-.17-.13.53.53,0,0,0-.26,0,.83.83,0,0,0-.36.13,1.54,1.54,0,0,0-.3.22,1.74,1.74,0,0,0-.25.29,2.21,2.21,0,0,0-.18.34,1.21,1.21,0,0,0-.06.38.57.57,0,0,0,.06.29.31.31,0,0,0,.2.12,1.49,1.49,0,0,0,.36,0l.53-.11a2.25,2.25,0,0,1,.53-.06.64.64,0,0,1,.36.09.51.51,0,0,1,.2.27,1.18,1.18,0,0,1,.07.45,2.35,2.35,0,0,1-.11.68,2.92,2.92,0,0,1-.3.65,3.62,3.62,0,0,1-.47.58,3.05,3.05,0,0,1-.61.46,1.53,1.53,0,0,1-.6.22.85.85,0,0,1-.46-.06.66.66,0,0,1-.31-.26.73.73,0,0,1-.12-.41.25.25,0,0,1,0-.14.21.21,0,0,1,.08-.1l.23-.13.1,0a.17.17,0,0,1,.07.09.59.59,0,0,0,.1.17.35.35,0,0,0,.19.12.51.51,0,0,0,.28,0,1.05,1.05,0,0,0,.4-.15,2.42,2.42,0,0,0,.36-.27,2.51,2.51,0,0,0,.31-.35,1.86,1.86,0,0,0,.21-.39.91.91,0,0,0,.08-.39.38.38,0,0,0-.09-.28.38.38,0,0,0-.25-.1,1.55,1.55,0,0,0-.41,0l-.55.12a1.34,1.34,0,0,1-.47,0,.59.59,0,0,1-.31-.13.58.58,0,0,1-.18-.29,1.9,1.9,0,0,1-.05-.44,2.52,2.52,0,0,1,.08-.58,3.06,3.06,0,0,1,.25-.6,2.68,2.68,0,0,1,1-1Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "342.155px 271.904px"
    },
    id: "elrz46xey2esc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.13,270.91s.07,0,.1,0a.13.13,0,0,1,0,.11v.27a.33.33,0,0,1,0,.16.25.25,0,0,1-.1.12l-2.24,1.3a.11.11,0,0,1-.11,0,.12.12,0,0,1,0-.11V268a.35.35,0,0,1,0-.17.43.43,0,0,1,.11-.12l2.19-1.27a.11.11,0,0,1,.11,0,.15.15,0,0,1,0,.12v.26a.35.35,0,0,1,0,.17.22.22,0,0,1-.11.12l-1.81,1.05v1.56l1.69-1a.11.11,0,0,1,.11,0,.12.12,0,0,1,0,.11v.27a.38.38,0,0,1,0,.17.29.29,0,0,1-.11.11l-1.69,1V272Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "346.004px 269.655px"
    },
    id: "elyui2cqo3i3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.84,268.76a.11.11,0,0,1,.11,0,.15.15,0,0,1,0,.12v.26a.35.35,0,0,1,0,.17.22.22,0,0,1-.11.12l-2.25,1.3a.08.08,0,0,1-.11,0,.12.12,0,0,1,0-.11v-4.78a.32.32,0,0,1,0-.16.26.26,0,0,1,.11-.12l.22-.13a.09.09,0,0,1,.11,0,.15.15,0,0,1,0,.12v4.31Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "349.715px 268.082px"
    },
    id: "el0ilm87y4x7ul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,266.72a.11.11,0,0,1,.11,0,.12.12,0,0,1,0,.11v.27a.38.38,0,0,1,0,.17.43.43,0,0,1-.11.12l-2.24,1.29s-.07,0-.1,0a.13.13,0,0,1-.05-.11v-4.78a.33.33,0,0,1,.05-.16.34.34,0,0,1,.1-.13l2.2-1.26s.07,0,.1,0a.13.13,0,0,1,.05.11v.27a.33.33,0,0,1-.05.16.25.25,0,0,1-.1.12L352.52,264v1.56l1.7-1a.09.09,0,0,1,.1,0,.14.14,0,0,1,.05.12v.26a.37.37,0,0,1-.05.17.4.4,0,0,1-.1.12l-1.7,1v1.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "353.247px 265.46px"
    },
    id: "elybr5jcklzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,263.22c0,.23,0,.44,0,.63s0,.4,0,.62a1.17,1.17,0,0,0,.28.83c.18.15.43.13.76-.06a1.8,1.8,0,0,0,.45-.35,2.2,2.2,0,0,0,.3-.4,2.35,2.35,0,0,0,.19-.43,3.15,3.15,0,0,0,.09-.42.34.34,0,0,1,.06-.15.3.3,0,0,1,.09-.1l.25-.14a.07.07,0,0,1,.09,0s0,.05,0,.09a2.35,2.35,0,0,1-.09.59,3.85,3.85,0,0,1-.27.7,4.36,4.36,0,0,1-.48.7,2.73,2.73,0,0,1-.71.58,1.44,1.44,0,0,1-.64.22.81.81,0,0,1-.49-.14,1,1,0,0,1-.31-.45,2.23,2.23,0,0,1-.12-.73q0-.65,0-1.32a3.72,3.72,0,0,1,.12-.87,3.85,3.85,0,0,1,.31-.82,3.75,3.75,0,0,1,.49-.69,2.7,2.7,0,0,1,.64-.53,1.49,1.49,0,0,1,.71-.23.76.76,0,0,1,.48.15.83.83,0,0,1,.27.38,1.36,1.36,0,0,1,.09.48.31.31,0,0,1,0,.13.22.22,0,0,1-.09.1l-.25.15a.1.1,0,0,1-.09,0s-.05,0-.06-.09a1.58,1.58,0,0,0-.09-.31.52.52,0,0,0-.19-.22.56.56,0,0,0-.3-.05,1.21,1.21,0,0,0-.45.17,1.89,1.89,0,0,0-.76.82A3,3,0,0,0,356,263.22Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "357.008px 263.24px"
    },
    id: "elt8rjat654a7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.17,257.72s.07,0,.1,0a.13.13,0,0,1,.05.11v.27a.33.33,0,0,1-.05.16.25.25,0,0,1-.1.12l-1,.6v4.31a.38.38,0,0,1,0,.17.43.43,0,0,1-.11.12l-.23.13a.09.09,0,0,1-.1,0,.13.13,0,0,1,0-.11v-4.31l-1,.59a.08.08,0,0,1-.11,0,.12.12,0,0,1,0-.11v-.27a.32.32,0,0,1,0-.16.26.26,0,0,1,.11-.12Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "360.963px 260.723px"
    },
    id: "elasdlsnzvbxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.26,229.48a10.94,10.94,0,0,1-5.54-1.45c-4.64-2.68-7.31-8.83-7.31-16.86,0-15,9.15-32.41,20.4-38.91,5.07-2.92,10-3.3,13.88-1,4.65,2.68,7.32,8.82,7.32,16.86,0,15-9.16,32.41-20.4,38.9A16.85,16.85,0,0,1,343.26,229.48Zm15.9-58.13a15.3,15.3,0,0,0-7.55,2.29C340.8,179.88,332,196.71,332,211.17c0,7.45,2.38,13.09,6.52,15.48,3.37,1.95,7.74,1.58,12.29-1.05,10.81-6.24,19.61-23.08,19.61-37.53,0-7.45-2.38-13.1-6.52-15.49A9.36,9.36,0,0,0,359.16,171.35Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "351.21px 199.624px"
    },
    id: "elmbgqgy6pw6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.43,208.13a4.21,4.21,0,0,1-1.28,1.57V211l-.74.42v-1.24a2.73,2.73,0,0,1-1,.31,1.31,1.31,0,0,1-.8-.16l.41-1.62a1.33,1.33,0,0,0,.65.16,2.05,2.05,0,0,0,.78-.18v-1.9a3.29,3.29,0,0,1-.89.08.82.82,0,0,1-.6-.35,1.81,1.81,0,0,1-.25-1.09,4.42,4.42,0,0,1,1.74-3.45v-1.27l.74-.42v1.24a1.89,1.89,0,0,1,1.5-.17l-.37,1.61a1.7,1.7,0,0,0-1.13.06V205a2.94,2.94,0,0,1,.88-.09.79.79,0,0,1,.6.35,1.74,1.74,0,0,1,.25,1.07A4.16,4.16,0,0,1,339.43,208.13ZM337,205a.54.54,0,0,0,.4.07v-1.62a1.78,1.78,0,0,0-.41.57,1.45,1.45,0,0,0-.14.59A.45.45,0,0,0,337,205Zm1.54,2.65a1.31,1.31,0,0,0,.13-.57.47.47,0,0,0-.13-.39.65.65,0,0,0-.4-.08v1.57A1.76,1.76,0,0,0,338.55,207.67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "337.769px 205.855px"
    },
    id: "elz4jqgkfv2wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.52,204.51a3.27,3.27,0,0,1,.62,2.23,7.84,7.84,0,0,1-.4,2.44,8,8,0,0,1-1.24,2.33,7.12,7.12,0,0,1-2,1.78,5.29,5.29,0,0,1-1.85.68,2.42,2.42,0,0,1-1.54-.19l.8-2.89a1.93,1.93,0,0,0,1.18.24,3.68,3.68,0,0,0,2.58-1.63,2.88,2.88,0,0,0,.44-1.56c0-1.12-.55-1.36-1.66-.72l-.94.54v-2.09l1.83-4.24-3.78,2.18v-2.54l6.22-3.59v2.05l-2,4.68A1.59,1.59,0,0,1,346.52,204.51Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "343.632px 205.75px"
    },
    id: "elk8sjh8jf9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.14,194.72c.7.76,1.05,2.24,1.05,4.43a16,16,0,0,1-.56,4.31,11.15,11.15,0,0,1-1.6,3.44,7.46,7.46,0,0,1-2.37,2.23,4.19,4.19,0,0,1-1.36.54,1.9,1.9,0,0,1-1.1,0l.76-2.77a1.76,1.76,0,0,0,1.66-.28,4.46,4.46,0,0,0,1.79-2.06,8.3,8.3,0,0,0,.71-3.37,5.47,5.47,0,0,1-2.21,2.51,2.21,2.21,0,0,1-1.54.36,1.54,1.54,0,0,1-1.11-.85,4.18,4.18,0,0,1-.41-2,8.08,8.08,0,0,1,.45-2.66,7.94,7.94,0,0,1,1.21-2.29,5.73,5.73,0,0,1,1.71-1.54C352.46,193.94,353.44,194,354.14,194.72Zm-1.67,5.09a3.73,3.73,0,0,0,.42-1.72,1.49,1.49,0,0,0-.41-1.23c-.27-.22-.65-.19-1.13.09a2.8,2.8,0,0,0-1.08,1.17,3.7,3.7,0,0,0-.41,1.72,1.56,1.56,0,0,0,.41,1.26c.28.21.64.18,1.1-.08A2.83,2.83,0,0,0,352.47,199.81Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "351.518px 201.954px"
    },
    id: "elu43i6ijfw9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.15,199a.91.91,0,0,1-.21-.68,2,2,0,0,1,.21-.91,1.21,1.21,0,0,1,.51-.59.4.4,0,0,1,.51,0,.89.89,0,0,1,.2.68,2,2,0,0,1-.2.91,1.36,1.36,0,0,1-.51.62C356.45,199.13,356.28,199.13,356.15,199Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "356.656px 197.915px"
    },
    id: "elfnyazleou66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,189.07a4,4,0,0,1,.61,2.58,9.2,9.2,0,0,1-.33,2.52,6.48,6.48,0,0,1-.93,2,4.34,4.34,0,0,1-1.38,1.3,2.68,2.68,0,0,1-.79.32,1.16,1.16,0,0,1-.65,0l.45-1.62a1,1,0,0,0,1-.16,2.53,2.53,0,0,0,1-1.2,4.85,4.85,0,0,0,.42-2,3.22,3.22,0,0,1-1.29,1.47,1.32,1.32,0,0,1-.9.21.9.9,0,0,1-.65-.5,2.37,2.37,0,0,1-.24-1.17,4.8,4.8,0,0,1,.26-1.55,4.89,4.89,0,0,1,.71-1.34,3.67,3.67,0,0,1,1-.9C360.46,188.62,361,188.63,361.44,189.07Zm-1,3a2.13,2.13,0,0,0,.25-1,.87.87,0,0,0-.24-.71c-.16-.13-.38-.11-.66.05a1.67,1.67,0,0,0-.63.68,2.15,2.15,0,0,0-.24,1,.9.9,0,0,0,.24.73.55.55,0,0,0,.64,0A1.57,1.57,0,0,0,360.46,192Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "359.915px 193.284px"
    },
    id: "elz96cuei7hsg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.15,186.35a3.9,3.9,0,0,1,.62,2.58,9.12,9.12,0,0,1-.33,2.51,6.54,6.54,0,0,1-.93,2,4.27,4.27,0,0,1-1.39,1.3,2.57,2.57,0,0,1-.79.32,1,1,0,0,1-.64,0l.44-1.61a1,1,0,0,0,1-.16,2.6,2.6,0,0,0,1-1.2,5,5,0,0,0,.41-2,3.15,3.15,0,0,1-1.29,1.46,1.28,1.28,0,0,1-.9.22.91.91,0,0,1-.64-.5,2.43,2.43,0,0,1-.24-1.17,4.8,4.8,0,0,1,.26-1.55,4.64,4.64,0,0,1,.71-1.34,3.34,3.34,0,0,1,1-.9C365.18,185.89,365.74,185.91,366.15,186.35Zm-1,3a2.25,2.25,0,0,0,.25-1,.85.85,0,0,0-.24-.71c-.16-.13-.38-.11-.67.05a1.65,1.65,0,0,0-.62.68,2.11,2.11,0,0,0-.24,1,.91.91,0,0,0,.24.74c.16.12.37.11.64,0A1.69,1.69,0,0,0,365.18,189.32Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "364.631px 190.56px"
    },
    id: "elhpdn20vtkrk",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--standard-option--inject-75",
    className: "animable animator-active",
    style: {
      transformOrigin: "225.325px 290.281px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-75",
    className: "animable",
    style: {
      transformOrigin: "225.325px 290.281px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-75",
    className: "animable",
    style: {
      transformOrigin: "225.325px 290.281px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.81,423a6.72,6.72,0,0,0,3,5.27l2.48,1.43a6.81,6.81,0,0,0,5.56.26c-1.43.54-2.52-.28-2.52-2V223.67a6.25,6.25,0,0,1,.89-3l-8.56-4.94a6.25,6.25,0,0,0-.89,3Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "169.31px 323.081px"
    },
    id: "elch42206j7ni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluthqrxrqel9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "169.31px 323.081px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.81,423a6.72,6.72,0,0,0,3,5.27l2.48,1.43a6.81,6.81,0,0,0,5.56.26c-1.43.54-2.52-.28-2.52-2V223.67a6.25,6.25,0,0,1,.89-3l-8.56-4.94a6.25,6.25,0,0,0-.89,3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.31px 323.081px"
    },
    id: "el6qieq4edzaj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M175,429.13a2.42,2.42,0,0,1-.4.19h0l-.12,0a1.31,1.31,0,0,1-.46.08c-.71,0-.81-.82-.81-1.31V223.82a6,6,0,0,1,2.6-4.53l108.46-62.6a2,2,0,0,1,.93-.3c.15,0,.55,0,.73.67a2.79,2.79,0,0,1,.07.64V362c0,1.87,0,3-2.31,4.31Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "229.605px 292.895px"
    },
    id: "elo171us4bzf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,157.7v53.78l-112.8,65.13V223.82a5.37,5.37,0,0,1,.77-2.56,5.28,5.28,0,0,1,1.83-2l108.45-62.61a2.08,2.08,0,0,1,.93-.3c.16,0,.56,0,.74.67A2.74,2.74,0,0,1,286,157.7Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "229.6px 216.48px"
    },
    id: "elrta3g824xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5,237.47a3.91,3.91,0,0,1,1.74-.59,2.52,2.52,0,0,1,1.37.3,2.37,2.37,0,0,1,.9.93,2.93,2.93,0,0,1,.34,1.34.85.85,0,0,1-.1.4.59.59,0,0,1-.21.28l-1.94,1.11a.6.6,0,0,1-.33.11.64.64,0,0,1-.26-.13l-.14-.15a1,1,0,0,0-.28-.17,1,1,0,0,0-.44,0,1.93,1.93,0,0,0-.65.25,5.14,5.14,0,0,0-.54.37,3.27,3.27,0,0,0-.46.45,2.44,2.44,0,0,0-.33.54,1.73,1.73,0,0,0-.12.64.72.72,0,0,0,.14.49.62.62,0,0,0,.47.15,3.8,3.8,0,0,0,.88-.13l1.36-.36a4.9,4.9,0,0,1,1.43-.18,1.65,1.65,0,0,1,1,.39,2.14,2.14,0,0,1,.61,1,6.4,6.4,0,0,1,.2,1.74,7.85,7.85,0,0,1-.34,2.27,9.4,9.4,0,0,1-1,2.12,9.5,9.5,0,0,1-1.45,1.83,9,9,0,0,1-1.83,1.39,4.36,4.36,0,0,1-1.83.65,2.44,2.44,0,0,1-1.43-.26,2.26,2.26,0,0,1-.94-1,3.26,3.26,0,0,1-.36-1.5,1,1,0,0,1,.1-.41.56.56,0,0,1,.21-.27l1.94-1.12a.6.6,0,0,1,.33-.11.5.5,0,0,1,.24.1l.17.2a1,1,0,0,0,.82.32,1.71,1.71,0,0,0,.75-.27,5.56,5.56,0,0,0,1.31-1,1.8,1.8,0,0,0,.53-1.25.51.51,0,0,0-.19-.46,1,1,0,0,0-.58-.09,6.42,6.42,0,0,0-1,.19l-1.41.37a2.15,2.15,0,0,1-2.23-.39,4.07,4.07,0,0,1-.7-2.73,7.84,7.84,0,0,1,.29-2,9.48,9.48,0,0,1,.83-2.05,9.64,9.64,0,0,1,1.33-1.85A7.49,7.49,0,0,1,191.5,237.47Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "191.551px 245.701px"
    },
    id: "elxpwjwd41hhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.24,229.18a.22.22,0,0,1,.28,0,.5.5,0,0,1,.12.37V232a1.11,1.11,0,0,1-.12.5.74.74,0,0,1-.28.35l-2.6,1.5V246a1.19,1.19,0,0,1-.12.51.75.75,0,0,1-.28.34L201.3,248a.21.21,0,0,1-.28,0,.49.49,0,0,1-.12-.36V235.92l-2.61,1.5a.21.21,0,0,1-.28,0,.49.49,0,0,1-.12-.36v-2.42a1.11,1.11,0,0,1,.12-.5.79.79,0,0,1,.28-.35Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "202.265px 238.592px"
    },
    id: "el9tc9did31aa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.52,225c.2-.11.35-.12.46,0a.89.89,0,0,1,.21.38l3.23,12.49a1.1,1.1,0,0,1,.06.31,1,1,0,0,1-.1.41.6.6,0,0,1-.23.28l-1.86,1.07c-.2.12-.34.14-.43.06a.58.58,0,0,1-.15-.29l-.42-1.65-3.93,2.27-.42,2.13a1.92,1.92,0,0,1-.15.47,1,1,0,0,1-.43.43l-1.86,1.08a.17.17,0,0,1-.23,0,.4.4,0,0,1-.1-.29,1.88,1.88,0,0,1,.06-.38l3.23-16.22a2.58,2.58,0,0,1,.22-.62,1.1,1.1,0,0,1,.45-.52Zm-2.39,11.34,2.39-1.38-1.2-4.78Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "212.325px 234.699px"
    },
    id: "elxfq86hlq66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.52,233.43c-.17.1-.3.11-.41,0a.75.75,0,0,1-.2-.21l-3.39-5.83v7.7a1.25,1.25,0,0,1-.11.5.8.8,0,0,1-.29.35l-1.94,1.12a.22.22,0,0,1-.28,0,.5.5,0,0,1-.11-.37V222a1.13,1.13,0,0,1,.11-.5.86.86,0,0,1,.28-.35l1.54-.88c.17-.1.31-.11.41,0a.62.62,0,0,1,.2.2l3.39,5.84v-7.71a1.18,1.18,0,0,1,.12-.5.7.7,0,0,1,.28-.34l1.94-1.12a.21.21,0,0,1,.28,0,.46.46,0,0,1,.12.36v14.72a1.19,1.19,0,0,1-.12.51.75.75,0,0,1-.28.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "224.125px 226.848px"
    },
    id: "elc8p2s07gynf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,212a4.13,4.13,0,0,1,1.87-.61,2.24,2.24,0,0,1,1.46.47,3.22,3.22,0,0,1,1,1.46,7.82,7.82,0,0,1,.39,2.34c0,.31,0,.61,0,.87v1.52c0,.25,0,.54,0,.85a13.68,13.68,0,0,1-.38,2.8,12.41,12.41,0,0,1-.94,2.54,10.11,10.11,0,0,1-1.43,2.14,7.22,7.22,0,0,1-1.85,1.53l-4,2.31a.21.21,0,0,1-.28,0,.49.49,0,0,1-.12-.36V215.13a1.18,1.18,0,0,1,.12-.5.75.75,0,0,1,.28-.34Zm1.94,5.15c-.06-1.71-.73-2.2-2-1.46l-1.51.88v8.65l1.58-.91a4.08,4.08,0,0,0,1.94-3.74c0-.32,0-.63,0-.91v-1.63C237.92,217.78,237.91,217.48,237.9,217.17Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "236.219px 220.831px"
    },
    id: "elxzoaxtrchr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66,204.69c.2-.11.35-.11.45,0a.86.86,0,0,1,.22.38l3.23,12.49a1.8,1.8,0,0,1,.06.31,1,1,0,0,1-.1.41.61.61,0,0,1-.23.28l-1.86,1.08c-.2.11-.34.13-.43.05a.54.54,0,0,1-.15-.29l-.42-1.65L245.5,220l-.42,2.13a1.8,1.8,0,0,1-.15.47,1.07,1.07,0,0,1-.43.44l-1.86,1.07a.18.18,0,0,1-.23,0,.41.41,0,0,1-.1-.3,2,2,0,0,1,.06-.38l3.23-16.22a3,3,0,0,1,.21-.62,1.09,1.09,0,0,1,.46-.51ZM246.27,216l2.39-1.39-1.2-4.78Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "247.464px 214.38px"
    },
    id: "elwa6xnujk4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.34,198.53a5.35,5.35,0,0,1,1.74-.69,1.89,1.89,0,0,1,1.31.2,2.07,2.07,0,0,1,.83,1.15,6.72,6.72,0,0,1,.29,2.15,9.75,9.75,0,0,1-.46,3.1,8.2,8.2,0,0,1-1.3,2.47l1.83,4.37a.59.59,0,0,1,.05.22.86.86,0,0,1-.1.41.55.55,0,0,1-.23.28l-2,1.16c-.2.12-.34.13-.42,0a.94.94,0,0,1-.2-.29L259,209.17l-1.36.79v4.87a1.11,1.11,0,0,1-.12.5.68.68,0,0,1-.28.35l-1.94,1.12a.21.21,0,0,1-.28,0,.5.5,0,0,1-.12-.37V201.69a1.18,1.18,0,0,1,.12-.5.76.76,0,0,1,.28-.34Zm-1.68,7.87,1.68-1a3.12,3.12,0,0,0,1-1,2.66,2.66,0,0,0,.41-1.56c0-.64-.13-1-.41-1.09a1.32,1.32,0,0,0-1,.23l-1.68,1Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "259.264px 207.327px"
    },
    id: "el0kmxz8kbucff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.64,192a4.17,4.17,0,0,1,1.87-.61,2.24,2.24,0,0,1,1.46.47,3.17,3.17,0,0,1,1,1.46,7.82,7.82,0,0,1,.39,2.34c0,.31,0,.6,0,.87V198c0,.26,0,.55,0,.85a13.59,13.59,0,0,1-.38,2.8,12.28,12.28,0,0,1-.94,2.55,10.38,10.38,0,0,1-1.43,2.14,7.22,7.22,0,0,1-1.85,1.53l-4,2.31a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37V195.11a1.18,1.18,0,0,1,.12-.5.7.7,0,0,1,.28-.34Zm1.94,5.15c-.06-1.71-.73-2.2-2-1.46l-1.51.87v8.66l1.58-.91a4.1,4.1,0,0,0,1.94-3.74c0-.33,0-.63,0-.91V198C272.6,197.76,272.59,197.46,272.58,197.15Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "270.859px 200.809px"
    },
    id: "el80ue6infxah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.16 197.51 232.53 200.42 235.6 199.25 233.38 203.42 233.91 207.19 231.16 206.85 228.41 210.37 228.93 205.99 226.71 204.38 229.78 202.01 231.16 197.51",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "231.155px 203.94px"
    },
    id: "elkzys5cpkpgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.56 200.03 223.54 202.11 225.74 201.27 224.15 204.25 224.53 206.95 222.56 206.7 220.6 209.21 220.98 206.08 219.39 204.94 221.58 203.24 222.56 200.03",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "222.565px 204.62px"
    },
    id: "elmsojtpjq6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.1,157.11a1.7,1.7,0,0,1,0,.44V361.84c0,1.77,0,2.5-1.89,3.58L174.52,428.24a1.08,1.08,0,0,1-.24.12h0l-.06,0-.09,0a2,2,0,0,1,0-.45V223.67a4.61,4.61,0,0,1,.68-2.16,4.28,4.28,0,0,1,1.49-1.62l108.45-62.6a1.5,1.5,0,0,1,.4-.18m.11-1.73a2.84,2.84,0,0,0-1.37.41L175.39,218.4a6.1,6.1,0,0,0-2.14,2.27,6.22,6.22,0,0,0-.89,3V428c0,1.39.68,2.18,1.67,2.18a2.27,2.27,0,0,0,.74-.13l.1,0a3.82,3.82,0,0,0,.54-.26l108.71-62.81c2.74-1.55,2.76-3.12,2.76-5.07V157.55a3.69,3.69,0,0,0-.11-.86,1.58,1.58,0,0,0-1.56-1.31Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "229.62px 292.78px"
    },
    id: "elrqjvlnhj18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.78,156.68c-.35-1.29-1.53-1.7-2.94-.89L175.4,218.4a6,6,0,0,0-2.15,2.27l-8.55-4.94a6.1,6.1,0,0,1,2.14-2.27l108.43-62.61a6.8,6.8,0,0,1,6.09,0l2.48,1.43A6.72,6.72,0,0,1,286.78,156.68Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "225.74px 185.4px"
    },
    id: "elbqgqdb2nfir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1korsa7q1ev"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "225.74px 185.4px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.78,156.68c-.35-1.29-1.53-1.7-2.94-.89L175.4,218.4a6,6,0,0,0-2.15,2.27l-8.55-4.94a6.1,6.1,0,0,1,2.14-2.27l108.43-62.61a6.8,6.8,0,0,1,6.09,0l2.48,1.43A6.72,6.72,0,0,1,286.78,156.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "225.74px 185.4px"
    },
    id: "elmsmdbk8hqub",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M205.69,347.77a.74.74,0,0,1-.63-.36.71.71,0,0,1,.27-1l64.3-37.1a.72.72,0,1,1,.72,1.25l-64.3,37.1A.8.8,0,0,1,205.69,347.77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "237.833px 328.492px"
    },
    id: "elx5h2dxh9y2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69,354a.74.74,0,0,1-.63-.36.71.71,0,0,1,.27-1l64.3-37.1a.72.72,0,1,1,.72,1.25l-64.3,37.09A.7.7,0,0,1,205.69,354Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "237.833px 334.722px"
    },
    id: "el48l8b9tkjdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,364a.77.77,0,0,1-.36-.09.73.73,0,0,1-.36-.63v-8.52a.73.73,0,0,1,.36-.62l7.35-4.24a.72.72,0,0,1,1.08.62V359a.72.72,0,0,1-.36.62l-7.35,4.25A.74.74,0,0,1,189.24,364Zm.72-8.82V362l5.91-3.41v-6.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "192.915px 356.902px"
    },
    id: "el5rl77ld8tux",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,359.09a.7.7,0,0,1-.5-.2l-2-1.86a.73.73,0,0,1,1-1l1.21,1.16,3.55-7.93a.72.72,0,0,1,.95-.37.73.73,0,0,1,.36,1l-4,8.86a.71.71,0,0,1-.51.41Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "194.284px 353.994px"
    },
    id: "elrm1x85bs8rj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69,366a.72.72,0,0,1-.36-1.34l64.3-37.1a.72.72,0,0,1,1,.27.71.71,0,0,1-.27,1l-64.3,37.1A.8.8,0,0,1,205.69,366Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "237.856px 346.729px"
    },
    id: "elxuqi31osj2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69,372.23a.74.74,0,0,1-.63-.36.71.71,0,0,1,.27-1l64.3-37.1a.72.72,0,1,1,.72,1.25l-64.3,37.1A.8.8,0,0,1,205.69,372.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "237.833px 352.952px"
    },
    id: "eljcsd9gfyuoi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,382.19a.77.77,0,0,1-.36-.09.73.73,0,0,1-.36-.63V373a.73.73,0,0,1,.36-.63l7.35-4.24a.71.71,0,0,1,.72,0,.73.73,0,0,1,.36.62v8.52a.71.71,0,0,1-.36.62l-7.35,4.25A.74.74,0,0,1,189.24,382.19Zm.72-8.82v6.86l5.91-3.41V370Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "192.915px 375.113px"
    },
    id: "elnw75qninp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,377.33a.7.7,0,0,1-.5-.2l-2-1.86a.73.73,0,0,1,1-1l1.21,1.16,3.55-7.93a.71.71,0,0,1,.95-.36.72.72,0,0,1,.36,1l-4,8.86a.72.72,0,0,1-.51.42Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "194.286px 372.247px"
    },
    id: "ell6px8dam3p9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,379.66l38-21.93c2.19-1.26,4-.23,4,2.3v5.88a8.76,8.76,0,0,1-4,6.87l-38,21.93c-2.19,1.26-4,.24-4-2.29v-5.88A8.8,8.8,0,0,1,210.63,379.66Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "229.63px 376.221px"
    },
    id: "el2rk0rbtqdhz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.59,380.12a1.69,1.69,0,0,1,.79-.27,1,1,0,0,1,.57.12.83.83,0,0,1,.36.36,1,1,0,0,1,.13.48.23.23,0,0,1,0,.17.28.28,0,0,1-.12.14l-.3.17a.15.15,0,0,1-.12,0,.18.18,0,0,1-.1-.12,1.36,1.36,0,0,0-.12-.17.58.58,0,0,0-.23-.17.73.73,0,0,0-.34,0,1.21,1.21,0,0,0-.48.17,2.19,2.19,0,0,0-.39.29,3,3,0,0,0-.33.38,1.6,1.6,0,0,0-.23.45,1.43,1.43,0,0,0-.09.5.67.67,0,0,0,.08.38.41.41,0,0,0,.27.16,1.29,1.29,0,0,0,.47,0l.7-.13a2.79,2.79,0,0,1,.7-.09,1,1,0,0,1,.47.12.74.74,0,0,1,.27.35,2.08,2.08,0,0,1,.08.6,3.06,3.06,0,0,1-.14.89,4.18,4.18,0,0,1-.4.86,3.69,3.69,0,0,1-.62.76,3.94,3.94,0,0,1-.8.61,2,2,0,0,1-.78.29,1.22,1.22,0,0,1-.62-.07,1,1,0,0,1-.4-.35,1.11,1.11,0,0,1-.16-.55.45.45,0,0,1,.05-.18.26.26,0,0,1,.11-.12l.3-.18a.22.22,0,0,1,.13,0s.07,0,.1.12a1,1,0,0,0,.13.22.63.63,0,0,0,.25.16.87.87,0,0,0,.37,0,1.65,1.65,0,0,0,.52-.2,2.74,2.74,0,0,0,.48-.36,2.55,2.55,0,0,0,.41-.46,2.12,2.12,0,0,0,.28-.51,1.6,1.6,0,0,0,.1-.52.47.47,0,0,0-.12-.36.5.5,0,0,0-.33-.13,1.76,1.76,0,0,0-.54,0l-.72.16a2,2,0,0,1-.62.05.8.8,0,0,1-.42-.17.94.94,0,0,1-.23-.39,2.34,2.34,0,0,1-.07-.57,3.11,3.11,0,0,1,.11-.77,3.58,3.58,0,0,1,.33-.79,3.36,3.36,0,0,1,.54-.73A3.25,3.25,0,0,1,217.59,380.12Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "217.67px 383.64px"
    },
    id: "elmj8qg1cabaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.23,382.32a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.35a.49.49,0,0,1-.06.22.45.45,0,0,1-.14.16l-2.95,1.7a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-6.29a.49.49,0,0,1,.06-.22.44.44,0,0,1,.14-.16l2.89-1.66a.11.11,0,0,1,.14,0,.18.18,0,0,1,.06.15v.36a.42.42,0,0,1-.06.21.38.38,0,0,1-.14.16l-2.4,1.38v2.06l2.24-1.29a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.35a.49.49,0,0,1-.06.22.41.41,0,0,1-.14.15l-2.24,1.29v2.14Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "222.755px 380.659px"
    },
    id: "eldxni8rapg0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.12,379.5a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15V380a.42.42,0,0,1-.06.21.38.38,0,0,1-.14.16l-3,1.72a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-6.29a.49.49,0,0,1,.06-.22.37.37,0,0,1,.14-.16l.3-.17a.12.12,0,0,1,.14,0,.17.17,0,0,1,0,.15v5.68Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "227.62px 378.595px"
    },
    id: "elcway7er5cp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.78,376.81a.14.14,0,0,1,.14,0,.22.22,0,0,1,.05.16v.35a.63.63,0,0,1-.05.22.41.41,0,0,1-.14.15l-2.95,1.71a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15V373a.46.46,0,0,1,.06-.22.37.37,0,0,1,.14-.16l2.89-1.67a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.35a.46.46,0,0,1-.06.22.38.38,0,0,1-.14.16l-2.4,1.38v2.06l2.24-1.29a.11.11,0,0,1,.14,0,.18.18,0,0,1,.06.15v.36a.42.42,0,0,1-.06.21.38.38,0,0,1-.14.16l-2.24,1.29v2.13Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "232.3px 375.175px"
    },
    id: "el6hbf2b2aals",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,372.2c0,.3,0,.58,0,.83s0,.52,0,.81a1.47,1.47,0,0,0,.37,1.09c.23.2.57.18,1-.07a2.81,2.81,0,0,0,.59-.46,3.21,3.21,0,0,0,.4-.53,3,3,0,0,0,.24-.56c0-.19.1-.38.13-.56a.48.48,0,0,1,.07-.2.34.34,0,0,1,.12-.12l.33-.2a.13.13,0,0,1,.12,0,.17.17,0,0,1,0,.13,3.09,3.09,0,0,1-.12.77,4.85,4.85,0,0,1-.36.92,5,5,0,0,1-.63.92,3.68,3.68,0,0,1-.93.77,2.09,2.09,0,0,1-.85.29,1,1,0,0,1-.64-.19,1.27,1.27,0,0,1-.41-.59,3,3,0,0,1-.16-1q0-.85,0-1.74a5,5,0,0,1,.16-1.14,5.6,5.6,0,0,1,.41-1.08,4.51,4.51,0,0,1,.64-.91,3.3,3.3,0,0,1,.85-.69,1.94,1.94,0,0,1,.93-.32,1.07,1.07,0,0,1,.63.2,1.19,1.19,0,0,1,.36.51,1.76,1.76,0,0,1,.12.63.42.42,0,0,1,0,.18.28.28,0,0,1-.12.12l-.33.2a.17.17,0,0,1-.12,0s-.06-.05-.07-.12a2.8,2.8,0,0,0-.13-.41.67.67,0,0,0-.24-.28.64.64,0,0,0-.4-.07,1.49,1.49,0,0,0-.59.22,2.49,2.49,0,0,0-1,1.08A3.7,3.7,0,0,0,236,372.2Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "237.326px 372.201px"
    },
    id: "elfvh9r2yfwdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,365a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.35a.49.49,0,0,1-.06.22.45.45,0,0,1-.14.16l-1.37.78v5.68a.49.49,0,0,1-.06.22.35.35,0,0,1-.13.16l-.3.17a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15V367l-1.37.79s-.1,0-.13,0a.2.2,0,0,1-.06-.16v-.35a.42.42,0,0,1,.06-.21.31.31,0,0,1,.13-.16Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "242.29px 368.945px"
    },
    id: "eltb497h5lfys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.15,327.77a14.45,14.45,0,0,1-7.29-1.9c-6.12-3.54-9.62-11.63-9.62-22.21,0-19.69,12-42.67,26.85-51.22,6.67-3.85,13.16-4.35,18.28-1.39,6.12,3.53,9.63,11.62,9.63,22.2,0,19.7-12.05,42.68-26.86,51.23A22.22,22.22,0,0,1,219.15,327.77Zm20.93-76.53a20.15,20.15,0,0,0-9.94,3c-14.23,8.22-25.81,30.38-25.81,49.41,0,9.81,3.12,17.25,8.58,20.39,4.44,2.57,10.19,2.08,16.18-1.38,14.24-8.22,25.82-30.39,25.82-49.42,0-9.81-3.13-17.24-8.59-20.39A12.33,12.33,0,0,0,240.08,251.24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "229.62px 288.456px"
    },
    id: "elvtofx90te4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.11,300a6.56,6.56,0,0,1-1.89,2.31v1.88l-1.09.63v-1.83a4.44,4.44,0,0,1-1.54.45,1.94,1.94,0,0,1-1.18-.23l.6-2.4a1.88,1.88,0,0,0,1,.23,2.77,2.77,0,0,0,1.15-.26v-2.8a5,5,0,0,1-1.31.11,1.23,1.23,0,0,1-.9-.51,2.72,2.72,0,0,1-.36-1.6,6.4,6.4,0,0,1,.66-2.78,6.21,6.21,0,0,1,1.91-2.32V289l1.09-.63v1.83a2.84,2.84,0,0,1,2.22-.25l-.55,2.38a2.53,2.53,0,0,0-1.67.09v2.86a4.52,4.52,0,0,1,1.29-.13,1.18,1.18,0,0,1,.89.51,2.66,2.66,0,0,1,.37,1.58A6.27,6.27,0,0,1,214.11,300Zm-3.58-4.6a.83.83,0,0,0,.6.1v-2.39a2.61,2.61,0,0,0-.61.84,2,2,0,0,0-.2.88A.66.66,0,0,0,210.53,295.35Zm2.28,3.91a2,2,0,0,0,.2-.84.66.66,0,0,0-.21-.57.84.84,0,0,0-.58-.13V300A2.52,2.52,0,0,0,212.81,299.26Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "211.609px 296.595px"
    },
    id: "elmpd9aa0pnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,286.55v20.19l-3,1.75V292.05l-2.62,1.51v-3.75Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "218.05px 297.52px"
    },
    id: "el6fz7digbi3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.07,282.31q1.55,1.68,1.55,6.53a23.48,23.48,0,0,1-.83,6.37,16.64,16.64,0,0,1-2.35,5.08,11,11,0,0,1-3.51,3.29,6.63,6.63,0,0,1-2,.8,2.83,2.83,0,0,1-1.63-.08l1.12-4.09a2.63,2.63,0,0,0,2.46-.41,6.61,6.61,0,0,0,2.64-3,12.45,12.45,0,0,0,1-5,8.19,8.19,0,0,1-3.26,3.7A3.43,3.43,0,0,1,225,296a2.3,2.3,0,0,1-1.63-1.27,6.09,6.09,0,0,1-.6-2.95,11.92,11.92,0,0,1,.66-3.93,11.67,11.67,0,0,1,1.79-3.39,8.5,8.5,0,0,1,2.52-2.27Q230.51,280.63,232.07,282.31Zm-2.47,7.51a5.43,5.43,0,0,0,.63-2.54,2.2,2.2,0,0,0-.61-1.81c-.4-.33-1-.28-1.68.13a4.14,4.14,0,0,0-1.58,1.72,5.34,5.34,0,0,0-.61,2.55,2.23,2.23,0,0,0,.61,1.85c.41.32.95.28,1.62-.11A4.24,4.24,0,0,0,229.6,289.82Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "228.192px 292.951px"
    },
    id: "elpwkglp4ueb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,288.62a1.37,1.37,0,0,1-.31-1,3,3,0,0,1,.31-1.35,2,2,0,0,1,.75-.88.61.61,0,0,1,.76,0,1.3,1.3,0,0,1,.3,1,3.24,3.24,0,0,1-.3,1.36,2,2,0,0,1-.76.9A.58.58,0,0,1,235,288.62Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "235.752px 287.015px"
    },
    id: "elc67b340wt97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,274c.61.66.91,1.92.91,3.81a13.32,13.32,0,0,1-.49,3.71,9.51,9.51,0,0,1-1.37,3,6.38,6.38,0,0,1-2,1.92,4,4,0,0,1-1.17.47,1.74,1.74,0,0,1-1,0l.65-2.38a1.52,1.52,0,0,0,1.43-.24,3.83,3.83,0,0,0,1.55-1.77,7.43,7.43,0,0,0,.61-2.9,4.74,4.74,0,0,1-1.9,2.15,2,2,0,0,1-1.34.32,1.36,1.36,0,0,1-.95-.74,3.59,3.59,0,0,1-.35-1.72,6.84,6.84,0,0,1,.39-2.29,6.73,6.73,0,0,1,1-2,4.94,4.94,0,0,1,1.47-1.33C241.4,273.3,242.24,273.32,242.84,274Zm-1.44,4.38a3.12,3.12,0,0,0,.37-1.48,1.32,1.32,0,0,0-.35-1.06c-.24-.18-.57-.16-1,.08a2.44,2.44,0,0,0-.93,1,3.24,3.24,0,0,0-.35,1.49,1.34,1.34,0,0,0,.35,1.08.82.82,0,0,0,1-.07A2.4,2.4,0,0,0,241.4,278.35Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "240.583px 280.234px"
    },
    id: "elex3csdatzl6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,270c.6.66.91,1.93.91,3.81a13.64,13.64,0,0,1-.49,3.71,9.67,9.67,0,0,1-1.37,3,6.61,6.61,0,0,1-2,1.92,3.94,3.94,0,0,1-1.17.46,1.65,1.65,0,0,1-.95-.05l.65-2.38a1.53,1.53,0,0,0,1.43-.24,3.81,3.81,0,0,0,1.54-1.77,7.22,7.22,0,0,0,.62-2.9,4.78,4.78,0,0,1-1.91,2.16,2,2,0,0,1-1.33.31,1.34,1.34,0,0,1-.95-.74,3.59,3.59,0,0,1-.35-1.72,7.14,7.14,0,0,1,.38-2.29,7,7,0,0,1,1-2,4.94,4.94,0,0,1,1.47-1.33C248.36,269.28,249.2,269.3,249.8,270Zm-1.44,4.38a3.09,3.09,0,0,0,.37-1.48,1.26,1.26,0,0,0-.36-1.05c-.23-.19-.56-.17-1,.07a2.47,2.47,0,0,0-.93,1,3.2,3.2,0,0,0-.35,1.48,1.33,1.33,0,0,0,.35,1.08c.24.18.55.16.95-.06A2.55,2.55,0,0,0,248.36,274.33Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "247.568px 276.204px"
    },
    id: "eljhej7cc4p6j",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--free-option--inject-75",
    className: "animable",
    style: {
      transformOrigin: "102.72px 342.612px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-75",
    className: "animable",
    style: {
      transformOrigin: "102.72px 342.612px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-75",
    className: "animable",
    style: {
      transformOrigin: "102.72px 342.612px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,443.41a5.1,5.1,0,0,0,2.31,4l1.89,1.09a5.16,5.16,0,0,0,4.22.19c-1.09.41-1.91-.21-1.91-1.52V292a4.71,4.71,0,0,1,.67-2.28L56.66,286a4.69,4.69,0,0,0-.68,2.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "60.2px 367.526px"
    },
    id: "elkf9y29nsi6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.47,448.05a2.2,2.2,0,0,1-.31.15h0l-.09,0a1.17,1.17,0,0,1-.35.06c-.54,0-.62-.63-.62-1V292.11a4.09,4.09,0,0,1,.59-1.94,3.87,3.87,0,0,1,1.39-1.49l82.37-47.55a1.5,1.5,0,0,1,.71-.23c.12,0,.42,0,.56.51a2.63,2.63,0,0,1,.05.49V397.06c0,1.42,0,2.28-1.76,3.28Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "105.935px 344.58px"
    },
    id: "elz4dvkcary57",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.81,241.89v40.85L63.13,332.21V292.12a4.5,4.5,0,0,1,2-3.44l82.37-47.56a1.59,1.59,0,0,1,.71-.22c.12,0,.42,0,.55.51A2,2,0,0,1,148.81,241.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "105.97px 286.555px"
    },
    id: "elkrgddee4j7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,290.77a.15.15,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.83a.85.85,0,0,1-.09.38.61.61,0,0,1-.21.27l-3.36,1.94v2.37L97.39,296a.15.15,0,0,1,.21,0,.34.34,0,0,1,.09.28v1.83a.73.73,0,0,1-.09.38.48.48,0,0,1-.21.26l-3.13,1.82v3.73a.94.94,0,0,1-.1.39A.63.63,0,0,1,94,305l-1.47.85a.15.15,0,0,1-.21,0,.36.36,0,0,1-.09-.28V294.38a.92.92,0,0,1,.09-.39.63.63,0,0,1,.21-.26Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "95.0746px 298.31px"
    },
    id: "eliuth8emx0fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31,287.48a4,4,0,0,1,1.32-.52,1.44,1.44,0,0,1,1,.15,1.65,1.65,0,0,1,.63.87,5.26,5.26,0,0,1,.22,1.63,7.55,7.55,0,0,1-.35,2.36,6.48,6.48,0,0,1-1,1.88l1.39,3.31a.38.38,0,0,1,0,.17.68.68,0,0,1-.08.31.44.44,0,0,1-.17.22l-1.53.88c-.15.09-.26.1-.32,0a.62.62,0,0,1-.15-.22l-1.25-3-1,.6v3.7a.86.86,0,0,1-.1.38.61.61,0,0,1-.21.27l-1.47.85a.16.16,0,0,1-.21,0,.34.34,0,0,1-.09-.28V289.88a.78.78,0,0,1,.09-.38.56.56,0,0,1,.21-.26Zm-1.27,6,1.27-.73a2.47,2.47,0,0,0,.78-.73,2.13,2.13,0,0,0,.31-1.18c0-.49-.11-.76-.31-.83a1,1,0,0,0-.78.17l-1.27.74Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "103.233px 294.144px"
    },
    id: "elltn13ptgub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24,290.51a.18.18,0,0,1,.22,0,.37.37,0,0,1,.09.27v1.84a.88.88,0,0,1-.09.38.53.53,0,0,1-.22.26l-5.33,3.08a.15.15,0,0,1-.21,0,.35.35,0,0,1-.09-.27V284.88a.92.92,0,0,1,.09-.38.63.63,0,0,1,.21-.26l5.24-3a.18.18,0,0,1,.22,0,.38.38,0,0,1,.09.28v1.83a.85.85,0,0,1-.09.38.56.56,0,0,1-.22.27l-3.46,2v1.87l3.22-1.86a.16.16,0,0,1,.21,0,.39.39,0,0,1,.09.28v1.84a.92.92,0,0,1-.09.38.63.63,0,0,1-.21.26l-3.22,1.86v1.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "111.58px 288.793px"
    },
    id: "elt4lg4jowpka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.32,285.85a.15.15,0,0,1,.21,0,.37.37,0,0,1,.09.27V288a.88.88,0,0,1-.09.38.57.57,0,0,1-.21.26L117,291.7a.17.17,0,0,1-.22,0,.35.35,0,0,1-.09-.27V280.22a.92.92,0,0,1,.09-.38.58.58,0,0,1,.22-.26l5.24-3a.16.16,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.83a.85.85,0,0,1-.09.38.61.61,0,0,1-.21.27l-3.47,2v1.87l3.22-1.86a.16.16,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.84a.92.92,0,0,1-.09.38.63.63,0,0,1-.21.26L118.76,286v1.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "119.655px 284.141px"
    },
    id: "elsrcy4tfvvwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.14 272.13 108.18 274.34 110.51 273.45 108.83 276.62 109.22 279.49 107.14 279.23 105.05 281.9 105.45 278.57 103.76 277.35 106.09 275.55 107.14 272.13",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "107.135px 277.015px"
    },
    id: "el2kdiub2dkuf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.11,241.45a1.29,1.29,0,0,1,0,.33V397c0,1.34,0,1.89-1.44,2.71L64.12,447.38l-.18.08h0l-.06,0a1.25,1.25,0,0,1,0-.34V292a3.51,3.51,0,0,1,.51-1.65,3.35,3.35,0,0,1,1.13-1.22l82.38-47.55a.94.94,0,0,1,.3-.13m.08-1.32a2.18,2.18,0,0,0-1,.31L64.78,288a4.6,4.6,0,0,0-1.62,1.73,4.69,4.69,0,0,0-.68,2.28V447.16c0,1.06.52,1.66,1.27,1.66a1.66,1.66,0,0,0,.56-.1.13.13,0,0,0,.08,0,2.09,2.09,0,0,0,.4-.19l82.57-47.71c2.08-1.18,2.1-2.37,2.1-3.84V241.78a3.13,3.13,0,0,0-.08-.66,1.21,1.21,0,0,0-1.19-1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "105.97px 344.47px"
    },
    id: "elg71zlqtr3fl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.38,241.12c-.27-1-1.16-1.29-2.23-.68L64.79,288a4.52,4.52,0,0,0-1.63,1.72L56.66,286a4.7,4.7,0,0,1,1.63-1.73l82.35-47.55a5.17,5.17,0,0,1,4.63,0l1.88,1.09A5.06,5.06,0,0,1,149.38,241.12Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "103.02px 262.946px"
    },
    id: "elgh0ng3jid84",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,386.26a.53.53,0,0,1-.47-.28.54.54,0,0,1,.2-.74l48.84-28.18a.55.55,0,0,1,.55.95L88.07,386.18A.57.57,0,0,1,87.79,386.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "112.201px 371.631px"
    },
    id: "elzu4b761gl3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,391a.55.55,0,0,1-.27-1l48.84-28.18a.55.55,0,0,1,.55,1L88.07,390.91A.55.55,0,0,1,87.79,391Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "112.243px 376.376px"
    },
    id: "elf79nqlj8lgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,398.55a.53.53,0,0,1-.27-.08.55.55,0,0,1-.27-.47v-6.47a.52.52,0,0,1,.27-.47l5.58-3.23a.59.59,0,0,1,.55,0,.55.55,0,0,1,.27.48v6.47a.55.55,0,0,1-.27.47l-5.58,3.22A.57.57,0,0,1,75.3,398.55Zm.55-6.7v5.2l4.49-2.59v-5.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.0949px 393.156px"
    },
    id: "el60sfty6mcml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35,394.85a.55.55,0,0,1-.38-.15l-1.48-1.41a.55.55,0,0,1,.75-.8l.93.88,2.69-6a.54.54,0,0,1,.72-.28.55.55,0,0,1,.28.72l-3,6.74a.54.54,0,0,1-.39.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "79.1259px 390.951px"
    },
    id: "elo2o1ma8wva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,400.11a.55.55,0,0,1-.47-.27.55.55,0,0,1,.2-.75l48.84-28.18a.55.55,0,0,1,.75.21.54.54,0,0,1-.2.74L88.07,400A.55.55,0,0,1,87.79,400.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "112.215px 385.474px"
    },
    id: "eljqhzrnypyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,404.83a.53.53,0,0,1-.47-.27.55.55,0,0,1,.2-.75l48.84-28.17a.55.55,0,0,1,.55.95L88.07,404.76A.55.55,0,0,1,87.79,404.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "112.201px 390.206px"
    },
    id: "el2bhk2uw8vx7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,412.4a.52.52,0,0,1-.27-.07.55.55,0,0,1-.27-.48v-6.46a.55.55,0,0,1,.27-.48l5.58-3.22a.55.55,0,0,1,.82.47v6.47a.55.55,0,0,1-.27.48l-5.58,3.22A.55.55,0,0,1,75.3,412.4Zm.55-6.7v5.21l4.49-2.59v-5.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.095px 407.01px"
    },
    id: "el7jdutnestx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35,408.71a.61.61,0,0,1-.38-.15l-1.48-1.42a.54.54,0,0,1,.75-.79l.93.88,2.69-6a.55.55,0,0,1,1,.45l-3,6.73a.57.57,0,0,1-.39.32Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "79.107px 404.837px"
    },
    id: "elzfb6xjeu1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.54,410.48l28.85-16.66c1.67-1,3-.18,3,1.74V400a6.64,6.64,0,0,1-3,5.22L91.54,421.91c-1.66,1-3,.18-3-1.74V415.7A6.67,6.67,0,0,1,91.54,410.48Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "105.965px 407.865px"
    },
    id: "el86uvzr6o1dp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.85,410.82a1.33,1.33,0,0,1,.59-.2.87.87,0,0,1,.44.09.66.66,0,0,1,.27.28.7.7,0,0,1,.1.36.16.16,0,0,1,0,.13.3.3,0,0,1-.09.1l-.23.13s-.07,0-.09,0,0,0-.08-.09l-.09-.14a.43.43,0,0,0-.17-.12.53.53,0,0,0-.26,0,.83.83,0,0,0-.36.13,1.29,1.29,0,0,0-.3.22,1.37,1.37,0,0,0-.25.29,1.24,1.24,0,0,0-.18.34,1,1,0,0,0-.07.38.53.53,0,0,0,.06.28.33.33,0,0,0,.21.13,1.51,1.51,0,0,0,.36,0l.53-.11a1.79,1.79,0,0,1,.53-.06.64.64,0,0,1,.36.09.51.51,0,0,1,.2.27,1.44,1.44,0,0,1,.06.45,2.22,2.22,0,0,1-.1.67,3.31,3.31,0,0,1-.31.66,3.15,3.15,0,0,1-.47.58,2.79,2.79,0,0,1-.61.46,1.44,1.44,0,0,1-.59.22.89.89,0,0,1-.47-.06.7.7,0,0,1-.3-.26.74.74,0,0,1-.12-.42.35.35,0,0,1,0-.13.22.22,0,0,1,.09-.1l.23-.13.09,0a.15.15,0,0,1,.08.09.42.42,0,0,0,.1.17.41.41,0,0,0,.19.12.62.62,0,0,0,.28,0,1.39,1.39,0,0,0,.39-.15,2.4,2.4,0,0,0,.37-.28,2,2,0,0,0,.31-.34,1.86,1.86,0,0,0,.21-.39,1.18,1.18,0,0,0,.08-.39.38.38,0,0,0-.09-.28.41.41,0,0,0-.26-.1,1.48,1.48,0,0,0-.4,0l-.55.12a1.65,1.65,0,0,1-.47,0,.62.62,0,0,1-.32-.13.56.56,0,0,1-.17-.29,1.46,1.46,0,0,1-.06-.44,2.05,2.05,0,0,1,.09-.58,3,3,0,0,1,.24-.6,2.73,2.73,0,0,1,.42-.56A2.22,2.22,0,0,1,96.85,410.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "96.9022px 413.494px"
    },
    id: "el0un2y0yuhxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,412.5s.07,0,.1,0a.13.13,0,0,1,.05.11v.27a.33.33,0,0,1-.05.16.25.25,0,0,1-.1.12l-2.25,1.3a.09.09,0,0,1-.1,0s0-.06,0-.12v-4.77a.35.35,0,0,1,0-.17.25.25,0,0,1,.1-.12l2.2-1.27a.11.11,0,0,1,.11,0s0,.06,0,.12v.26a.35.35,0,0,1,0,.17.26.26,0,0,1-.11.12L100,409.73v1.56l1.7-1a.09.09,0,0,1,.1,0,.13.13,0,0,1,.05.11v.27a.33.33,0,0,1-.05.16.2.2,0,0,1-.1.12l-1.7,1v1.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "100.785px 411.235px"
    },
    id: "el4uveftwm60v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,410.35a.11.11,0,0,1,.11,0,.17.17,0,0,1,0,.12v.26a.53.53,0,0,1,0,.17.32.32,0,0,1-.11.12l-2.26,1.3s-.07,0-.1,0a.13.13,0,0,1,0-.11v-4.78a.33.33,0,0,1,0-.16.25.25,0,0,1,.1-.12l.23-.14a.11.11,0,0,1,.11,0,.15.15,0,0,1,0,.12v4.31Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "104.474px 409.658px"
    },
    id: "elkhtnfteat4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.14,408.31a.09.09,0,0,1,.1,0,.13.13,0,0,1,.05.11v.27a.41.41,0,0,1-.05.17.4.4,0,0,1-.1.12l-2.24,1.29a.11.11,0,0,1-.11,0,.12.12,0,0,1,0-.11v-4.78a.38.38,0,0,1,0-.17.43.43,0,0,1,.11-.12l2.19-1.26s.08,0,.11,0a.15.15,0,0,1,0,.12v.27a.34.34,0,0,1,0,.16.22.22,0,0,1-.11.12l-1.81,1.05v1.56l1.69-1a.11.11,0,0,1,.11,0s0,.06,0,.12v.26a.35.35,0,0,1,0,.17.43.43,0,0,1-.11.12l-1.69,1v1.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "108.033px 407.057px"
    },
    id: "ellzth26xn8wh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.79,404.81c0,.23,0,.44,0,.63s0,.4,0,.61a1.15,1.15,0,0,0,.28.84c.18.15.43.13.76-.06a2,2,0,0,0,.45-.35,2.2,2.2,0,0,0,.3-.4,1.78,1.78,0,0,0,.18-.43,2.13,2.13,0,0,0,.1-.42.34.34,0,0,1,.06-.15.21.21,0,0,1,.08-.1l.26-.14a.08.08,0,0,1,.09,0s0,0,0,.09a2.42,2.42,0,0,1-.09.59,3.3,3.3,0,0,1-.28.7,3.36,3.36,0,0,1-.48.7,2.85,2.85,0,0,1-.7.58,1.47,1.47,0,0,1-.65.22.8.8,0,0,1-.48-.14.89.89,0,0,1-.31-.45,2.22,2.22,0,0,1-.13-.73c0-.44,0-.87,0-1.32a3.74,3.74,0,0,1,.13-.87,3.38,3.38,0,0,1,.31-.82,4.24,4.24,0,0,1,.48-.69,2.75,2.75,0,0,1,.65-.53,1.33,1.33,0,0,1,.7-.23.73.73,0,0,1,.48.15.78.78,0,0,1,.28.38,1.36,1.36,0,0,1,.09.48.31.31,0,0,1,0,.13.3.3,0,0,1-.09.1l-.26.15a.08.08,0,0,1-.08,0s0,0-.06-.09a1.12,1.12,0,0,0-.1-.31.44.44,0,0,0-.18-.22.56.56,0,0,0-.3-.05,1.15,1.15,0,0,0-.45.17,1.89,1.89,0,0,0-.76.82A2.78,2.78,0,0,0,110.79,404.81Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "111.793px 404.83px"
    },
    id: "el7ph58oh823r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.92,399.3a.11.11,0,0,1,.11,0,.15.15,0,0,1,0,.12v.26a.35.35,0,0,1,0,.17.22.22,0,0,1-.11.12l-1,.6v4.31a.41.41,0,0,1,0,.17.4.4,0,0,1-.1.12l-.23.13a.11.11,0,0,1-.11,0s0-.06,0-.12v-4.31l-1,.6s-.07,0-.1,0a.13.13,0,0,1,0-.11v-.27a.33.33,0,0,1,0-.16.25.25,0,0,1,.1-.12Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "115.705px 402.3px"
    },
    id: "el3denetv2c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,371.07a10.94,10.94,0,0,1-5.54-1.45c-4.64-2.68-7.31-8.83-7.31-16.86,0-15,9.15-32.42,20.4-38.91,5.07-2.93,10-3.3,13.88-1.06,4.65,2.69,7.31,8.83,7.31,16.87,0,15-9.15,32.41-20.4,38.9A16.81,16.81,0,0,1,98,371.07Zm15.9-58.13a15.42,15.42,0,0,0-7.56,2.28c-10.81,6.25-19.6,23.08-19.6,37.54,0,7.45,2.38,13.09,6.52,15.48,3.37,1.95,7.74,1.58,12.29-1.05,10.81-6.24,19.61-23.08,19.61-37.53,0-7.45-2.38-13.1-6.52-15.49A9.41,9.41,0,0,0,113.92,312.94Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "105.945px 341.207px"
    },
    id: "elg18oq66bojc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.42,347.86a4.31,4.31,0,0,1-1.28,1.57v1.27l-.74.43v-1.24a2.76,2.76,0,0,1-1,.3,1.23,1.23,0,0,1-.8-.15l.4-1.63a1.29,1.29,0,0,0,.66.16,1.92,1.92,0,0,0,.78-.18v-1.9a3.32,3.32,0,0,1-.89.08.86.86,0,0,1-.61-.35,1.83,1.83,0,0,1-.24-1.08,4.41,4.41,0,0,1,1.74-3.46v-1.26l.74-.43v1.24a1.93,1.93,0,0,1,1.5-.17l-.37,1.62a1.58,1.58,0,0,0-1.13.06v1.93a3.74,3.74,0,0,1,.88-.09.82.82,0,0,1,.6.35,1.82,1.82,0,0,1,.24,1.07A4.19,4.19,0,0,1,97.42,347.86ZM95,344.74a.57.57,0,0,0,.41.08V343.2a1.79,1.79,0,0,0-.42.56,1.62,1.62,0,0,0-.13.6A.44.44,0,0,0,95,344.74Zm1.55,2.65a1.24,1.24,0,0,0,.13-.56.47.47,0,0,0-.13-.39.61.61,0,0,0-.4-.09v1.57A1.65,1.65,0,0,0,96.54,347.39Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "95.7533px 345.56px"
    },
    id: "el5n5rievwmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.41,352.77a2.56,2.56,0,0,1-1.35-1.65,10.22,10.22,0,0,1-.49-3.52,16,16,0,0,1,.49-4.08,10.88,10.88,0,0,1,1.35-3.22,5.78,5.78,0,0,1,2-2,2.19,2.19,0,0,1,2-.3,2.62,2.62,0,0,1,1.36,1.65,10.54,10.54,0,0,1,.48,3.52,16.45,16.45,0,0,1-.48,4.09,11,11,0,0,1-1.36,3.21,6,6,0,0,1-2,2A2.23,2.23,0,0,1,100.41,352.77Zm3.24-4.78a11.3,11.3,0,0,0,.46-3.59,6.86,6.86,0,0,0-.46-3.06.82.82,0,0,0-1.27-.34,3.15,3.15,0,0,0-1.27,1.81,11.26,11.26,0,0,0-.46,3.59,6.78,6.78,0,0,0,.46,3.05.82.82,0,0,0,1.27.35A3.18,3.18,0,0,0,103.65,348Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "102.41px 345.383px"
    },
    id: "elshyadka44j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.15,342.75a.91.91,0,0,1-.21-.68,2,2,0,0,1,.21-.91,1.4,1.4,0,0,1,.51-.6.42.42,0,0,1,.51,0,.87.87,0,0,1,.21.67,2.1,2.1,0,0,1-.21.92,1.32,1.32,0,0,1-.51.61A.39.39,0,0,1,107.15,342.75Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "107.66px 341.662px"
    },
    id: "elkawg9ou9di",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9,341a1.49,1.49,0,0,1-.79-1,6,6,0,0,1-.29-2.05,9.46,9.46,0,0,1,.29-2.38,6.27,6.27,0,0,1,.79-1.87,3.3,3.3,0,0,1,1.14-1.15,1.31,1.31,0,0,1,1.15-.18,1.54,1.54,0,0,1,.79,1,6,6,0,0,1,.28,2,9.42,9.42,0,0,1-.28,2.38,6.27,6.27,0,0,1-.79,1.87,3.44,3.44,0,0,1-1.15,1.16A1.32,1.32,0,0,1,109.9,341Zm1.89-2.79a6.58,6.58,0,0,0,.27-2.09,4,4,0,0,0-.27-1.78.48.48,0,0,0-.75-.2,1.84,1.84,0,0,0-.73,1.05,6.58,6.58,0,0,0-.27,2.09,4,4,0,0,0,.27,1.78.47.47,0,0,0,.73.2A1.82,1.82,0,0,0,111.79,338.25Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "111.04px 336.678px"
    },
    id: "ele8ewuz56tf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.92,338.14a1.57,1.57,0,0,1-.79-1,6,6,0,0,1-.28-2.05,9.42,9.42,0,0,1,.28-2.38,6.54,6.54,0,0,1,.79-1.87,3.54,3.54,0,0,1,1.15-1.16,1.33,1.33,0,0,1,1.15-.17,1.6,1.6,0,0,1,.79,1,6.28,6.28,0,0,1,.28,2.05,9.89,9.89,0,0,1-.28,2.38,6.84,6.84,0,0,1-.79,1.87,3.54,3.54,0,0,1-1.15,1.16A1.33,1.33,0,0,1,114.92,338.14Zm1.89-2.79a6.61,6.61,0,0,0,.27-2.1,4,4,0,0,0-.27-1.78.47.47,0,0,0-.74-.19,1.85,1.85,0,0,0-.74,1.05,6.58,6.58,0,0,0-.27,2.09,4,4,0,0,0,.27,1.78.48.48,0,0,0,.74.2A1.81,1.81,0,0,0,116.81,335.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "116.069px 333.825px"
    },
    id: "el1kde76hfjrm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-75",
    className: "animable",
    style: {
      transformOrigin: "328.58px 349.754px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-75",
    className: "animable",
    style: {
      transformOrigin: "328.58px 349.754px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-75",
    className: "animable",
    style: {
      transformOrigin: "319.977px 405.472px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.82,401.74l-7-16.76L293,392.83c9.1,10.44,18.81,23,20.85,27.44,0,0,10.5-1.52,12.52-6.66S322.47,403.7,319.82,401.74Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "309.891px 402.625px"
    },
    id: "el1d6zl7vwuyw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,409a8.55,8.55,0,0,1,2.11,2.67c.59,1,0,5.8.5,8.06s.91,2.9,1.77,5.76c.94,3.17,2.91,6.15-.13,13.89s-7.26,11.22-10.73,12.91a8.66,8.66,0,0,1-4.07.67s-4.23-2-3.37-4.49S331,409,331,409Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.922px 430.993px"
    },
    id: "elta0x9hwoghp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.24,416.23c.06.82,1.11,2.16,1.52,2.86,1.4,2.36,1.89,5.44,2.23,8.13,1.64,12.73-3.82,18.73,2.58,23.94,1.87,1.37,5.95,1.34,12.7-6.11,3.45-3.8,5.86-12,4.91-15.82s-2.45-6.42-3-9.37.24-8.31-1.18-10.91a11.52,11.52,0,0,0-3.66-3.66c-1.14-.82-3.69-2-4.86-2.75s-1.78-1.63-2.63-.8l1.28,1.85c2,3.2,1.32,3.6,1.15,5.22a25.09,25.09,0,0,0,.44,5.23c-1.42-2.09-1.93-3.87-3.66-3.69s-1.93.08-4.55,2.19S311.19,415.49,311.24,416.23Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "323.313px 426.628px"
    },
    id: "eli561mfptldb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldhcp2ct02h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.24,416.23c.06.82,1.11,2.16,1.52,2.86,1.4,2.36,1.89,5.44,2.23,8.13,1.64,12.73-3.82,18.73,2.58,23.94,1.87,1.37,5.95,1.34,12.7-6.11,3.45-3.8,5.86-12,4.91-15.82s-2.45-6.42-3-9.37.24-8.31-1.18-10.91a11.52,11.52,0,0,0-3.66-3.66c-1.14-.82-3.69-2-4.86-2.75s-1.78-1.63-2.63-.8l1.28,1.85c2,3.2,1.32,3.6,1.15,5.22a25.09,25.09,0,0,0,.44,5.23c-1.42-2.09-1.93-3.87-3.66-3.69s-1.93.08-4.55,2.19S311.19,415.49,311.24,416.23Z",
    style: {
      opacity: 0.4,
      transformOrigin: "323.313px 426.628px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz011nek65i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.27,445.05c3.45-3.8,5.86-12,4.91-15.82a34,34,0,0,0-1.18-3.75c0,.26.09.52.11.74,0,.49.07,1,.08,1.48a11.3,11.3,0,0,1-1.05,5.65c-.82,1.51-2.75,5.3-4.87,5.23-1.19,0-2.12-1.28-2.48-2.65-.15-.58-.36-2.12-.36-2.12a18.67,18.67,0,0,0-5.65,1.83c-3.21,1.8-3.13,2.25-3.13,2.25a8,8,0,0,1-.1,2.7,6.65,6.65,0,0,1-1.34,2.59,4.26,4.26,0,0,1-.82.56c-.09,2.91.5,5.24,3.18,7.42C319.44,452.53,323.52,452.5,330.27,445.05Z",
    style: {
      opacity: 0.3,
      transformOrigin: "324.885px 438.666px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315,427.22a41.9,41.9,0,0,1,0,10.08c.92,3.3,1.93,3.28,2.2,1.63s-1.45-8.73-2.67-14.55C314.74,425.34,314.88,426.3,315,427.22Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "315.879px 432.201px"
    },
    id: "elhmj22w0nha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.12,407.68a7,7,0,0,0-.89-4.68c-.29-.16-.56-.32-.78-.46-1.26-.85-1.78-1.63-2.63-.8l1.28,1.85c2,3.2,1.32,3.6,1.15,5.22a25.09,25.09,0,0,0,.44,5.23c.87,5.53,1.9,7.44,2.12,12.63s-1.06,8.56-.36,8.91,2.22-.13,2.79-4.23-.73-11.17-1.77-14.54S323.69,409.86,324.12,407.68Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "323.6px 418.53px"
    },
    id: "el5rew48pz04t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.77,434.19a.53.53,0,0,1-.27.13,12.32,12.32,0,0,0-8.58,4.2.51.51,0,1,1-.73-.72,13.32,13.32,0,0,1,9.18-4.5.51.51,0,0,1,.4.89Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "320.993px 435.984px"
    },
    id: "elokpk7a2av5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.44,429.86a.51.51,0,0,1-.27.12,13.8,13.8,0,0,0-9.05,4.62.51.51,0,0,1-.74,0,.53.53,0,0,1,0-.75,14.86,14.86,0,0,1,9.64-4.91.52.52,0,0,1,.6.44A.54.54,0,0,1,325.44,429.86Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "320.425px 431.846px"
    },
    id: "el5d8bz65pay4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.88,425.14a.6.6,0,0,1-.3.14,15.7,15.7,0,0,0-10.11,5.19.58.58,0,0,1-.83-.82,16.87,16.87,0,0,1,10.77-5.52.58.58,0,0,1,.66.48A.6.6,0,0,1,325.88,425.14Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "320.274px 427.383px"
    },
    id: "elu7gjfzao0y9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.49,421.06a.52.52,0,0,1-.28.13,15.28,15.28,0,0,0-9.9,5.07.58.58,0,0,1-.8,0,.57.57,0,0,1,0-.81A16.5,16.5,0,0,1,325,420.06a.58.58,0,0,1,.65.48A.57.57,0,0,1,325.49,421.06Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "320.001px 423.237px"
    },
    id: "elor9emrwpni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.31,417a.51.51,0,0,1-.29.13,15.33,15.33,0,0,0-9.9,5.07.56.56,0,0,1-.8,0,.55.55,0,0,1,0-.8,16.43,16.43,0,0,1,10.52-5.4.58.58,0,0,1,.65.48A.58.58,0,0,1,324.31,417Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "318.822px 419.181px"
    },
    id: "el3t7uh1x6yd3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.54,344.34s-42.62-5-59.31-4.94c-17,.11-18.61,12.9-14.35,20.73,8.16,15,34.52,45.63,34.52,45.63s10.6-3.2,13.52-11.45l-5.53-14.83,33,4.54,6-4.32Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "308.638px 372.58px"
    },
    id: "els5gvw6ke1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,391.08c3.66-4.67,6.09-5.76,12.68-8l4.21,11.27c-2.93,8.25-13.53,11.45-13.53,11.45s-3-3.53-7.37-8.78A64.4,64.4,0,0,1,300,391.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "306.44px 394.44px"
    },
    id: "el1jmuajbx31o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.11,365.46c2.14,3.18,4,6,5.57,8.77s6.49,4,11.48,3a95.6,95.6,0,0,0,17.13-5.61C340.5,366.54,341,360.3,341,360.3a22.47,22.47,0,0,0,7.58,12.17l-1.25,8.65L345,384l-28.4-3.91h0l-4.61-.63c-5.86-14-8.12-20.12-15.36-23C296.62,356.5,302.79,356,309.11,365.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "322.605px 370.23px"
    },
    id: "elgl3dby34gh6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.79,448.61,302.38,432l-15.32-13.28c-7.17,11.11-14.16,21.72-18.7,25.81,0,0,3,10.17,8.75,10.76S285.56,451.82,286.79,448.61Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "285.37px 437.034px"
    },
    id: "elzqydogsl9he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.1,458.63a9,9,0,0,1-2.1,2.86c-.87.88-5.83,1.65-8,2.75s-2.65,1.73-5.29,3.39c-2.93,1.84-5.38,4.64-14,3.74s-13.32-4.18-16-7.19a9.08,9.08,0,0,1-1.81-3.91s.8-4.81,3.58-4.65S283.1,458.63,283.1,458.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "259.5px 463.58px"
    },
    id: "el4g5pf9q743v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.27,440.8c-.81.29-1.87,1.71-2.46,2.33-2,2.06-4.95,3.41-7.56,4.51-12.35,5.2-19.92,1.38-23.37,9.27-.86,2.26.31,6.36,9.69,11.07,4.79,2.41,13.68,2.56,17.29.54s5.78-4.26,8.59-5.67,8.43-2.08,10.65-4.22a12.18,12.18,0,0,0,2.66-4.71c.51-1.38,1.93-6.12,1.93-6.12-2.67,2.88-5.21,1.73-6.88,2a26.74,26.74,0,0,0-5.14,1.89c1.71-2,3.35-3,2.69-4.71s-.62-1.92-3.48-4S271,440.54,270.27,440.8Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "262.169px 455.324px"
    },
    id: "el0o009e0b52ko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsbgk4yo7sts"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.27,440.8c-.81.29-1.87,1.71-2.46,2.33-2,2.06-4.95,3.41-7.56,4.51-12.35,5.2-19.92,1.38-23.37,9.27-.86,2.26.31,6.36,9.69,11.07,4.79,2.41,13.68,2.56,17.29.54s5.78-4.26,8.59-5.67,8.43-2.08,10.65-4.22a12.18,12.18,0,0,0,2.66-4.71c.51-1.38,1.93-6.12,1.93-6.12-2.67,2.88-5.21,1.73-6.88,2a26.74,26.74,0,0,0-5.14,1.89c1.71-2,3.35-3,2.69-4.71s-.62-1.92-3.48-4S271,440.54,270.27,440.8Z",
    style: {
      opacity: 0.4,
      transformOrigin: "262.169px 455.324px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvkhav0nagcr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.57,468c4.79,2.41,13.68,2.56,17.29.54a39.12,39.12,0,0,0,3.45-2.23c-.25.1-.5.23-.72.31-.48.18-1,.35-1.46.49a11.83,11.83,0,0,1-6,.53c-1.75-.41-6.11-1.3-6.63-3.45-.29-1.21.7-2.49,2-3.23.54-.32,2-1,2-1a19.51,19.51,0,0,0-3.42-5.17c-2.71-2.73-3.14-2.53-3.14-2.53a8.22,8.22,0,0,1-2.74.65,6.93,6.93,0,0,1-3-.62,4.44,4.44,0,0,1-.8-.67c-3,.72-5.13,2-6.58,5.27C236,459.17,237.19,463.27,246.57,468Z",
    style: {
      opacity: 0.3,
      transformOrigin: "251.958px 460.781px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,447.64a44.09,44.09,0,0,1-10.13,2.85c-3.06,1.84-2.76,2.86-1,2.66s8.37-3.89,13.9-6.75C262.08,446.86,261.14,447.27,260.25,447.64Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "255.411px 449.787px"
    },
    id: "el9sedeaeasu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.46,451.37c1.65-.13,2.93,0,4.34-.79.89-.45,1.4-2.5,1.36-3.43l-1.46,1.55c-2.48,1.1-4.22.83-5.89,1.11a26.74,26.74,0,0,0-5.14,1.89c-5.33,2.43-7,4-12.12,5.67s-8.92,1.31-9.07,2.12.75,2.19,5,1.62,11-3.85,14.14-5.83S280.15,451.55,282.46,451.37Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "271.313px 454.197px"
    },
    id: "el75o6d3jistg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.24,460.43a.6.6,0,0,1-.2-.24c-1.5-3.55-2.82-5.35-6.62-7.46a.53.53,0,0,1-.21-.73.54.54,0,0,1,.73-.21,13.93,13.93,0,0,1,7.09,8,.54.54,0,0,1-.79.66Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "253.105px 456.129px"
    },
    id: "el9eljdp9wjea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.51,458.89a.68.68,0,0,1-.2-.24,14.44,14.44,0,0,0-7.16-7.82.53.53,0,0,1-.21-.75.55.55,0,0,1,.75-.21,15.52,15.52,0,0,1,7.63,8.33.56.56,0,0,1-.81.69Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "257.111px 454.386px"
    },
    id: "elw1fj4a59c8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.38,458a.7.7,0,0,1-.22-.26,16.36,16.36,0,0,0-8-8.74.59.59,0,0,1-.23-.82.61.61,0,0,1,.83-.24,17.59,17.59,0,0,1,8.55,9.3.61.61,0,0,1-.3.8A.62.62,0,0,1,265.38,458Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "261.605px 452.986px"
    },
    id: "el1b4x165tcu1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.39,456.49a.63.63,0,0,1-.22-.26,16,16,0,0,0-7.86-8.54.6.6,0,0,1,.59-1,17.14,17.14,0,0,1,8.36,9.1.59.59,0,0,1-.3.78A.58.58,0,0,1,269.39,456.49Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "265.723px 451.639px"
    },
    id: "elp8297llzhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.12,454.17a.63.63,0,0,1-.22-.26,15.93,15.93,0,0,0-7.86-8.54.6.6,0,0,1,.59-1,17.12,17.12,0,0,1,8.36,9.09.59.59,0,0,1-.3.79A.61.61,0,0,1,273.12,454.17Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "269.455px 449.317px"
    },
    id: "eljr7g8f6wpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.92,431.64c3.73,6.71,13.83,12.29,13.83,12.29S296,440,306.36,431.64c7.28-5.92,13.27-11.78,17.56-18.93,12.33-2.47,34.74-3.12,57.47-10.09,11.66-3.57,19.57-11.24,21.93-22.3,1.23-5.78.95-16.3-1.11-23.83-5.34-19.55-62.71-10.73-62.71-10.73l9.12,26.71s-27.42,10.45-36.75,14.29c-4.29,1.77-5.51,1.71-10.58,8.76C289.7,411.63,277.92,431.64,277.92,431.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "340.987px 393.853px"
    },
    id: "elcn373h3jbf5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.79,442.1l-.8-.54c5.49-5.17,19.33-18.59,23.55-24.28,1.45-2,2.59-3.71,3.59-5.26,2.36-3.63,3.92-6,6.75-6.72.61-.15,2.08-.45,4.29-.9,11.28-2.31,41.25-8.45,51.65-14.08.31-.17.6-.35.9-.53-3.57-3.53-3.17-10.29-.45-14.45,2.92-4.44,5.14-13.29,3.53-17.6l.89-.33c1.88,5-.89,14.29-3.63,18.45-2.55,3.9-2.83,10.36.51,13.43,10-6.23,15-17.13,14.54-31.68l.94,0c.49,15.76-5.31,27.37-16.78,33.57-10.53,5.7-40.59,11.86-51.91,14.18-2.12.43-3.66.75-4.25.89-2.47.6-3.95,2.88-6.19,6.32-1,1.56-2.15,3.32-3.62,5.31C307.87,423.83,293.89,437.29,288.79,442.1Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "341.534px 399.755px"
    },
    id: "el6q58y37soue",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-75",
    className: "animable",
    style: {
      transformOrigin: "349.152px 312.743px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-75",
    className: "animable",
    style: {
      transformOrigin: "320.757px 300.172px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.69,295.06c-6.72,6.08-12.18,11-14.58,13.12-6.17-4.68-9.94-7.11-13-9.45-4.47-3.4-7.41-5.52-7.9-9.1-.19-1.38-.53-3.21-.85-5.19-.62-3.79-1.32-6.44-1.45-8.82-.09-1.69-1.89-2.22-3.36.39-.87,1.56-.89,3.63-.94,5.84s-.92,1.72-2.29.27-7.6-8.55-9.67-10.88-2.83-2.41-3.31-2-1.58,1.84.89,5.19c2.59,3.52,5.74,7.65,5.76,7.79,0,.31-1.33-1.76-2.71-.38-2.24,2.22-.21,3.64-.21,3.64-.57-.06-1.2-1.4-2.5-.11-1.85,1.84.25,3.13.14,3.34s-1-1.35-2.21.17c-.9,1.11-.42,2.51,1,4.19s3.44,3.75,4.52,4.87c2.26,2.33,4,3.86,7.26,4.87,2.4.74,3.35,2.18,5.51,4.39s11.7,13.08,17.26,18.19c6.45,5.93,8.05,7.8,13.65,3.73l.08,0c11.79-7.68,25.24-20,25.24-20l12.45-28.7C355.43,279.81,349,283,335.69,295.06Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "320.757px 300.172px"
    },
    id: "elyppw1tqjk1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.09,285.62c-1.59,2.61-1.67,8.6.18,12.07C288.65,294.49,288.7,288.39,292.09,285.62Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "290.911px 291.655px"
    },
    id: "elkp2pyf1vjil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.78,283.31c1.81,2,3.64,4.19,3.58,5.28s-.66,1.81-1.56,1.8a3.2,3.2,0,0,1-1.5-.38,2.85,2.85,0,0,1,.76,1.7,2,2,0,0,1-1.91,1.51,2.68,2.68,0,0,1-1.52-.73s.86,1.22.54,2.1a1.79,1.79,0,0,1-2.69.44c.89.92,1.92,1.3,2.88.45s.48-1.62.48-1.62a2,2,0,0,0,2.15-.59,2.06,2.06,0,0,0,.62-2.37,1.87,1.87,0,0,0,2.61-1.68c.13-1.53-.63-2.42-1.93-3.82A12.17,12.17,0,0,0,285.78,283.31Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "285.857px 289.632px"
    },
    id: "elxfpyf3ro54q",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-75",
    className: "animable",
    style: {
      transformOrigin: "371.77px 324.272px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.78,323.63A18.38,18.38,0,0,1,342.26,301c7.83-12.11,22.18-20.59,22.18-20.59a103.47,103.47,0,0,1,13.11,1.05c6.08.88,23.2,8.07,23.2,8.07a29.25,29.25,0,0,0-2.69,14.75c.63,12.52,5.28,17.7,5.28,17.7s-3.41,12-4.21,15.15c-.54,2.12.48,6.47,1.6,10.47a98.83,98.83,0,0,1,3.33,16.93c-12.35,11.06-64-5.5-63.56-20.4,0-2.62,2.47-4.73,3.33-8A35.4,35.4,0,0,0,344.78,323.63Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "371.77px 324.272px"
    },
    id: "elgt4xjx18qdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,325.09s4.82,6,15.19,4.3,12.43-9.56,12.43-9.56.61,10.08-11.8,12.09C363.6,333.91,360,325.09,360,325.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.812px 326.021px"
    },
    id: "elufexumsq12n",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-75",
    className: "animable",
    style: {
      transformOrigin: "388.092px 261.501px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.36,228.13c16.74,1.76,21.83,7.74,20.87,14.39,5.07,2.59,7.13,8.65.57,21.86-2.84,5.72-8,9.55-8.8,12.75l-7.45-.4a16.22,16.22,0,0,0-9-14.09c-9.06-4.54-14.52-7.11-15.37-9.37C349,238.23,363.18,226.42,379.36,228.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.558px 252.548px"
    },
    id: "elt6pf4egeo2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,282.61c-3.14-1.31-5.65-3.52-6.59-6.79s-.34-7,.09-10.53a102.11,102.11,0,0,0,.69-13.88c-.05-3.2-.27-6.56-2-9.28-2.52-4-5.42-6.63-14.06-5.18a73.87,73.87,0,0,1-1.07,16.85c-.85,4.87-1.78,9.78-1.64,14.73s1.46,10,4.64,13.82,8.42,6.07,13.21,4.82a9.13,9.13,0,0,1-4.54-6.68C410.73,284.19,416.87,284.86,420,282.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "407.703px 262.032px"
    },
    id: "elf875m45kian",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,245.2a81.4,81.4,0,0,0-1.52,13.66c-.22,12.84,3.29,15.16,6,16.81,1.7,1,3.26,1.47,7.27,1.59l-.2,5.44s-10.08,8.4-1.57,11.88c3.27,1.34,10.67-.43,14.83-3.22s5.64-5,5.64-5l1.23-16.05s3.28,3.05,7.46-.5c3.24-2.75,4.16-8.73,1.42-11.33s-6.28-2.07-8.37,1.91c-1.49,2.83-3.52.36-2.74-2.78s-1.6-3.61-2.32-5.43c-2-5.1,1.46-8.27-3.37-11.12-3.27-1.92-10.67,3.09-12.88.69C365.77,235.29,362.1,239,360.82,245.2Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "381.144px 266.702px"
    },
    id: "elulrtdyw2gys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.65,265l-6.83,1.75a3.4,3.4,0,0,0,4.15,2.74A3.83,3.83,0,0,0,377.65,265Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "374.278px 267.292px"
    },
    id: "elpjpak01e1oi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.4,267.42a3.67,3.67,0,0,1-2.43,2.11,3.23,3.23,0,0,1-2.11-.17,3,3,0,0,1,3.1-2.47A2.89,2.89,0,0,1,377.4,267.42Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "375.13px 268.26px"
    },
    id: "elo4kardgp5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.39,254.87a1.86,1.86,0,0,0,1.88,1.86,1.91,1.91,0,1,0-1.88-1.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.299px 254.82px"
    },
    id: "elpxyhx8ia1zd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.46,253.15a1.82,1.82,0,1,0,1.78-1.94A1.86,1.86,0,0,0,363.46,253.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "365.277px 253.03px"
    },
    id: "eldb3ysezqtm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.93,250.05l4.32,2.39a2.71,2.71,0,0,0-1-3.53A2.36,2.36,0,0,0,378.93,250.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.235px 250.526px"
    },
    id: "elt6ufol08dqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.51,250.2l4.49-1.94a2.29,2.29,0,0,0-3.09-1.42A2.71,2.71,0,0,0,362.51,250.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.677px 248.427px"
    },
    id: "elnzzskkovmhs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.06 251.38 371.6 263.19 365.44 260.68 373.06 251.38",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "369.25px 257.285px"
    },
    id: "el5z9a3zifpf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.59,277.26a26.47,26.47,0,0,0,11.94-2.91c2.41-1.31,4.3-4.34,5.28-6.29-.19.45-.2,5.54-4.61,8.47-4.89,3.24-12.7,3.25-12.7,3.25Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "381.155px 273.92px"
    },
    id: "elg5th911y4io",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-75",
    className: "animable",
    style: {
      transformOrigin: "349.335px 343.51px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.13,376.34v1.09a3.09,3.09,0,0,1-1.52,2.67l-29.22,17a3.09,3.09,0,0,1-1.53.42,3,3,0,0,1-1.54-.41l-53.86-30.78a3.09,3.09,0,0,1-1.55-2.65v-.75l56.94,32.54Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "330.52px 380.225px"
    },
    id: "eljs5o5amsnaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.92,362.91l31.77-18.53a1.86,1.86,0,0,1,1.84,0L374.93,376a.41.41,0,0,1,0,.71l-32.07,18.7Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "330.527px 369.773px"
    },
    id: "eln6dr3zf1yjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.14 392.75 360.28 382.76 309.91 353.98 292.69 363.91 343.14 392.75",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "326.485px 373.365px"
    },
    id: "elhve3j5kymns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.46 365.15 351.15 365.33 342.75 370.23 327.74 361.65 327.42 361.47 336.14 356.39 351.46 365.15",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "339.44px 363.31px"
    },
    id: "eljx45w8ytd7s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.15 365.33 342.75 370.23 327.74 361.65 336.14 356.75 351.15 365.33",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "339.445px 363.49px"
    },
    id: "elilsq5lqon27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,395.45v2.05a3,3,0,0,1-1.54-.41l-53.86-30.78a3.09,3.09,0,0,1-1.55-2.65v-.75Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "314.385px 380.205px"
    },
    id: "elts24mo3s8dd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbmf00k6wzc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.5,
      transformOrigin: "314.385px 380.205px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.86,395.45v2.05a3,3,0,0,1-1.54-.41l-53.86-30.78a3.09,3.09,0,0,1-1.55-2.65v-.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "314.385px 380.205px"
    },
    id: "elj0mkqs1hchm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-75",
    className: "animable",
    style: {
      transformOrigin: "380.892px 335.276px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.54,340.83c-2-14.34-4-27.31-6.56-37.77-1.44-5.78-3.86-11.34-13.23-13.56-7.88,5.24-5.92,22.75-5,26.81l5.31,25.19s-6.83,5.27-14,10.19c-6.07,4.16-10,7.5-17.07,8.1s-9.86.28-13.57,1.75c-2,.78-6.47,2.6-8,3.32s-4.34,3.36-6.91,5.13.49,2.94,2.34,2.47a23.78,23.78,0,0,0,5.59-2.49,31.23,31.23,0,0,1,4.79-1.66,27.34,27.34,0,0,0-1.18,5.48c0,1-.3,2.23.55,3a7.81,7.81,0,0,0,2.08.94,1.54,1.54,0,0,0,.39,1,2.53,2.53,0,0,0,1.77.52,7.88,7.88,0,0,0,1-.12A1.85,1.85,0,0,0,360,380.6a8.11,8.11,0,0,0,4.29.29c.22-.08,1.84-.89,2.32-1.12a4.05,4.05,0,0,0,1.61-.95c.37-.51-.57-1.75-1.39-1.91a8.62,8.62,0,0,0-2.74.09,9.41,9.41,0,0,0,.87-2.33c.79-1.17,6.13.22,10.93-.45,3.63-.51,6.35-3.85,8-4.53,10.54-4.34,18.57-7.36,29.26-13.34C422.89,350.89,421.6,348.27,420.54,340.83Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "380.892px 335.276px"
    },
    id: "elqk34f63mvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,368.6c.6-1.34,1.5-2.94,2.55-3.28a12.16,12.16,0,0,0-1.61,3C353.92,368.42,353.61,368.51,353.3,368.6Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "354.575px 366.96px"
    },
    id: "elppo4dzk1wlo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.69,377.72a10.94,10.94,0,0,1,0-3,24.34,24.34,0,0,1,.48-2.94,12.88,12.88,0,0,1,.89-2.85,5.45,5.45,0,0,1,1.86-2.32,4.44,4.44,0,0,0-.85,1.17,8.24,8.24,0,0,0-.6,1.32,20,20,0,0,0-.75,2.81c-.22.95-.4,1.91-.6,2.87A25.52,25.52,0,0,0,355.69,377.72Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "357.253px 372.165px"
    },
    id: "elyrcqjc6zhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.88,379.11a14.22,14.22,0,0,1,.1-2.92,23,23,0,0,1,.53-2.87,20.55,20.55,0,0,1,.88-2.79,5.74,5.74,0,0,1,1.58-2.46,3.76,3.76,0,0,0-.7,1.25c-.17.44-.33.89-.46,1.35-.27.92-.53,1.85-.75,2.78C359.6,375.32,359.17,377.19,358.88,379.11Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "360.408px 373.59px"
    },
    id: "ela2rg2cc29pd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8,376.91a5.68,5.68,0,0,0-1.21.13c-.4.08-.68.27-1.17.41l.21-.31a1.31,1.31,0,0,1-.1.58,1.68,1.68,0,0,1-.29.44,1.84,1.84,0,0,1-.84.51,4.17,4.17,0,0,0,.52-.74,1.82,1.82,0,0,0,.13-.37,1.09,1.09,0,0,0,0-.34l0-.22.23-.09a3.59,3.59,0,0,1,1.14-.2A2.49,2.49,0,0,1,366.8,376.91Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "365.1px 377.678px"
    },
    id: "elcu2m0bb997e",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342,395.91a3.6,3.6,0,0,1-3.13-.23L285.24,365a3.59,3.59,0,0,1-1.78-2.53l-6-34.9a2.94,2.94,0,0,1-.05-.59,3.61,3.61,0,0,1,1.06-2.59l55.73,31.85a2.72,2.72,0,0,1,1.31,1.88Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "309.705px 360.277px"
    },
    id: "elnei0rzcb24c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3ziyfodazl2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "309.705px 360.277px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342,395.91a3.6,3.6,0,0,1-3.13-.23L285.24,365a3.59,3.59,0,0,1-1.78-2.53l-6-34.9a2.94,2.94,0,0,1-.05-.59,3.61,3.61,0,0,1,1.06-2.59l55.73,31.85a2.72,2.72,0,0,1,1.31,1.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "309.705px 360.277px"
    },
    id: "elxckve0w7x9n",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,395.45l-.37.22a3.85,3.85,0,0,1-.5.24l-6.49-37.76a2.72,2.72,0,0,0-1.31-1.88l-55.73-31.85a3.74,3.74,0,0,1,.74-.57L335,355.76a2.69,2.69,0,0,1,1.31,1.88Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "310.66px 359.88px"
    },
    id: "elrhi70zc5sp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.73,363.81c-.4-2.34-2.83-5.44-5.42-6.92s-4.37-.79-4,1.55,2.83,5.43,5.42,6.91S312.13,366.14,311.73,363.81Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "307.023px 361.12px"
    },
    id: "elebkja6oyljo",
    className: "animable"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingPlansNotCss);
export default __webpack_public_path__ + "static/media/pricing-plans-not-css.892ae15b4728656aa9d22d3dd206ff4d.svg";
export { ForwardRef as ReactComponent };